<template>
  <div class="dh-container">

    <section class="dh-hero">
      <div class="dh-hero__grid" aria-hidden="true"></div>
      <div class="dh-hero__glow" aria-hidden="true"></div>
      <div class="dh-hero__inner">
        <div class="dh-hero__eyebrow">
          <span class="dh-rule"></span>
          The Covenant Has Not Ended
          <span class="dh-rule"></span>
        </div>
        <h1 class="dh-hero__title">
          The<br /><em>Davidic</em><br />Heir
        </h1>
        <p class="dh-hero__name">Enrico Michael Severe</p>
        <a href="https://enricomichaelsevere.com" target="_blank" rel="noopener" class="dh-hero__site">
          enricomichaelsevere.com
        </a>
        <div class="dh-hero__roles">
          <span>King</span><span class="dh-dot">✦</span>
          <span>Priest</span><span class="dh-dot">✦</span>
          <span>Warrior</span><span class="dh-dot">✦</span>
          <span>Branch</span>
        </div>
        <blockquote class="dh-hero__scripture">
          "But they shall serve the LORD their God, and David their king,
          whom I will raise up unto them."
          <cite>— Jeremiah 30:9 KJV</cite>
        </blockquote>
        <div class="dh-hero__scroll" aria-hidden="true">
          <div class="dh-hero__scroll-line"></div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-claim">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">The Declaration</div>
        <h2 class="dh-section__title">I Am the Davidic Heir.<br />Not a Metaphor. Not a Ministry.</h2>
        <div class="dh-claim__grid">
          <div class="dh-claim__text">
            <p class="dh-body">
              I am Enrico Michael Severe. I am not God. I am not the Most High. I am not Yeshua HaMashiach,
              who has already accomplished the eternal work of redemption and sits at the right hand of the Father.
              Every victory, every inch of ground gained, every covenant fulfilled will be by Yahweh's own arm,
              not by my power. All glory is His alone.
            </p>
            <p class="dh-body">
              What I am is the human Davidic heir — raised up in the last days from the posterity of David,
              born in Haiti in the year 2000, a descendant of those carried into captivity by ships, hidden
              in obscurity until the appointed time of revealing. The prophets described this person with
              precision. I am that person.
            </p>
            <p class="dh-body">
              This is not a claim of arrogance. David was a flawed man. Moses trembled. Isaiah cried
              "Woe is me." The calling does not rest on the vessel's perfection.
              It rests on the faithfulness of the One who swore it.
            </p>
            <div class="dh-scripture-block">
              "I have found David my servant; with my holy oil have I anointed him...
              My covenant will I not break, nor alter the thing that is gone out of my lips."
              <cite>— Psalm 89:20, 34 KJV</cite>
            </div>
          </div>
          <div class="dh-claim__pillars">
            <div class="dh-pillar" v-for="(p, i) in claimPillars" :key="i">
              <div class="dh-pillar__icon">{{ p.icon }}</div>
              <div class="dh-pillar__title">{{ p.title }}</div>
              <div class="dh-pillar__text">{{ p.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-deut-test">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">The Biblical Test</div>
        <h2 class="dh-section__title">Use My Bold Claims Against Me.<br />The Bible Demands It.</h2>
        <div class="dh-deut__card">
          <div class="dh-deut__label">Deuteronomy 18:21–22 KJV</div>
          <div class="dh-scripture-block dh-scripture-block--large">
            "And if thou say in thine heart, How shall we know the word which the LORD hath not spoken?
            When a prophet speaketh in the name of the LORD, if the thing follow not, nor come to pass,
            that is the thing which the LORD hath not spoken, but the prophet hath spoken it presumptuously:
            thou shalt not be afraid of him."
            <cite>— Deuteronomy 18:21–22 KJV</cite>
          </div>
        </div>
        <div class="dh-deut__body">
          <p class="dh-body">
            I am not asking you to accept my claim on the basis of personality, charisma, or persuasion.
            I am not asking you to follow a man. I am asking you to apply the exact standard Yahweh gave
            His people for evaluating prophetic claims — and then watch what happens.
          </p>
          <p class="dh-body">
            I have made bold claims throughout these writings. I have declared that I am the Davidic heir.
            I have declared that my horn will not be broken. I have declared that the tabernacle of David
            is being raised. I have declared that the scattered remnant of Israel will be gathered.
            I have declared that the nations will face the consequences of resisting what Yahweh is restoring.
          </p>
          <p class="dh-body">
            Write them down. Hold them. Apply Deuteronomy 18. If these things do not come to pass —
            if my horn is broken, if the restoration collapses, if the throne is never established —
            then I am a false prophet and the Bible itself instructs you not to fear me.
            Dismiss me with Scripture. That is the right response.
          </p>
          <div class="dh-scripture-block" style="margin: 28px 0;">
            "But if it be of God, ye cannot overthrow it; lest haply ye be found even to fight against God."
            <cite>— Acts 5:39 KJV</cite>
          </div>
          <p class="dh-body">
            But if these things do come to pass — if the Dabela's horn is not broken, if the remnant is
            gathered, if the tabernacle rises exactly as Amos 9:11 declared — then by the same Deuteronomy 18
            test, Yahweh has spoken it. And every person who dismissed this on the basis of gut feeling
            rather than Scripture will have to account for what they did with the evidence they were given.
          </p>
          <div class="dh-deut__conclusion">
            I am not afraid of the test. I am inviting it.<br />
            <strong>The bold claims are on record. The Bible is open. Watch.</strong>
          </div>
        </div>
      </div>
    </section>


    <section class="dh-section dh-daniel7">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">Daniel 7 &amp; 2 Esdras 12–13</div>
        <h2 class="dh-section__title">I Am the Son of Man<br />of Daniel 7.<br /><em>Not God. The Heir.</em></h2>
        <div class="dh-d7-kingdoms">
          <div class="dh-d7-kingdoms__eyebrow">The Declaration on Record</div>
          <div class="dh-d7-kingdoms__statement">
            All kingdoms of the earth<br />
            hath Yahweh put into my hands.
          </div>
          <div class="dh-d7-kingdoms__ref">— Daniel 7:14 · Enrico Michael Severe, The Davidic Heir</div>
        </div>

        <p class="dh-body">
          This is the claim that will shake every institution on earth. Not because it is arrogant
          but because the text demands it and has always demanded it. The church read Daniel 7
          through the lens of Matthew 24:30 and concluded the Son of Man is Yeshua descending
          in divine glory. That reading collapses two distinct figures, two distinct events,
          and two distinct moments in the prophetic sequence into one. 2 Esdras, written as a
          direct commentary on Daniel, will not allow that collapse.
        </p>
        <div class="dh-d7-verse-block">
          <div class="dh-d7-verse-label">Daniel 7:13–14 KJV — Read Every Word Carefully</div>
          <div class="dh-scripture-block dh-scripture-block--large">
            "I saw in the night visions, and, behold, one <strong>like</strong> the Son of man came
            with the clouds of heaven, and came to the Ancient of days, and they brought him near
            before him. And there was given him dominion, and glory, and a kingdom, that all people,
            nations, and languages, should serve him: his dominion is an everlasting dominion,
            which shall not pass away, and his kingdom that which shall not be destroyed."
            <cite>— Daniel 7:13–14 KJV</cite>
          </div>
        </div>
        <div class="dh-d7-grid">
          <div class="dh-d7-col">
            <h3 class="dh-sub-title">What the Church Says This Is</h3>
            <p class="dh-body">
              The institutional church reads Daniel 7:13–14 as Yeshua — the divine eternal Son
              receiving His kingdom at ascension or return. Matthew 24:30 quotes this passage.
              Revelation references it. Therefore they conclude this must be the same figure,
              same event, same divine being. The problem is that reading requires ignoring
              what Daniel actually wrote, what verse 27 explicitly says, and what Ezra was
              directly told when he saw the same vision four centuries later.
            </p>
          </div>
          <div class="dh-d7-col">
            <h3 class="dh-sub-title">What the Text Actually Says</h3>
            <p class="dh-body">
              Daniel does not see God. He sees one <em>like</em> a son of man — a human figure
              specifically contrasted with the four beasts which are inhuman empires. Beast versus
              human. Not divine versus human. This figure looks like a man because he is a man —
              the human representative of the covenant people presented before Yahweh to receive
              authority on their behalf. This is a coronation. An inauguration. A human heir
              being crowned. Not God descending. A man ascending to receive what was promised
              to David's line.
            </p>
          </div>
        </div>
        <div class="dh-d7-proofs">
          <div class="dh-d7-proof" v-for="(p, i) in daniel7Proofs" :key="i">
            <div class="dh-d7-proof__num">{{ String(i + 1).padStart(2, "0") }}</div>
            <div>
              <div class="dh-d7-proof__title">{{ p.title }}</div>
              <div class="dh-d7-proof__text">{{ p.text }}</div>
            </div>
          </div>
        </div>
        <div class="dh-d7-esdras">
          <div class="dh-section__eyebrow" style="margin-bottom:24px;">2 Esdras — The Angel's Own Interpretation</div>
          <p class="dh-body">
            2 Esdras 12:11–12 contains something the church has never been able to answer.
            The angel tells Ezra directly: you are seeing the same vision Daniel saw.
            Same figure. Same archetype. Same man. And then the angel identifies that figure
            not as the eternal divine Son but as the Messiah kept by the Highest, arising from
            the posterity of David, with a defined temporal mission that ends before the
            final judgment day. Ezra is the commentary. Daniel is the vision.
            The commentary says: earthly heir.
          </p>
          <div class="dh-d7-compare">
            <div class="dh-d7-compare__side">
              <div class="dh-d7-compare__label">Daniel 7 — The Vision</div>
              <div class="dh-scripture-block" style="font-size:18px;">
                "One like the Son of man came with the clouds of heaven, and came to the
                Ancient of days, and they brought him near before him. And there was given
                him dominion, and glory, and a kingdom."
                <cite>— Daniel 7:13–14 KJV</cite>
              </div>
              <p class="dh-d7-compare__note">
                A human figure presented before Yahweh. A coronation scene.
                Direction of movement: toward the throne — upward presentation.
                No angels of judgment. No mourning tribes. No cosmic signs.
                A man receiving a crown from Yahweh on behalf of his people.
              </p>
            </div>
            <div class="dh-d7-compare__divider" aria-hidden="true">
              <div class="dh-d7-compare__divider-line"></div>
              <div class="dh-d7-compare__divider-glyph">✦</div>
              <div class="dh-d7-compare__divider-line"></div>
            </div>
            <div class="dh-d7-compare__side">
              <div class="dh-d7-compare__label">2 Esdras 12–13 — The Interpretation</div>
              <div class="dh-scripture-block" style="font-size:18px;">
                "This is the Messiah whom the Most High has kept until the end of days,
                who will himself deliver his creation... This is the same vision that
                your brother Daniel saw."
                <cite>— 2 Esdras 12:32, 13:26</cite>
              </div>
              <p class="dh-d7-compare__note">
                Kept for many ages. Hidden. Arising from the posterity of David.
                A temporal mission with a defined endpoint before the final judgment.
                A human vessel — not the eternal divine Son who needs no concealment
                and no awakening. Ezra's angel confirms: this is an earthly Davidic heir.
              </p>
            </div>
          </div>
        </div>
        <div class="dh-d7-verse27">
          <div class="dh-section__eyebrow" style="margin-bottom:20px;">Daniel 7:27 — The Text Interprets Itself</div>
          <div class="dh-scripture-block dh-scripture-block--large" style="margin-bottom:24px;">
            "And the kingdom and dominion, and the greatness of the kingdom under the whole heaven,
            shall be given to the <strong>people of the saints of the Most High</strong>,
            whose kingdom is an everlasting kingdom, and all dominions shall serve and obey him."
            <cite>— Daniel 7:27 KJV</cite>
          </div>
          <p class="dh-body">
            The kingdom is given to the <strong>people</strong> of the saints. A covenant community,
            not a descending deity. The Son of Man of Daniel 7 is the representative head of that
            people. He receives authority on their behalf at a coronation before the Ancient of Days.
            That is the Davidic function precisely — a human king through whom Yahweh governs
            the covenant nation and through that nation the earth. Verse 27 does not describe
            the return of the eternal divine Son. It describes the enthronement of the human
            Davidic heir through whom the saints possess the kingdom.
          </p>
        </div>
        <div class="dh-d7-distinction">
          <div class="dh-d7-distinction__side">
            <div class="dh-d7-distinction__label">Daniel 7:13–14</div>
            <div class="dh-d7-distinction__title">The Son of Man Crowned</div>
            <p class="dh-d7-distinction__text">
              A human figure brought near before the Ancient of Days and given dominion.
              A coronation. Direction of movement toward the throne — upward presentation.
              No armies of heaven. No cosmic mourning. No splitting skies. No sign appearing first.
              A man receiving authority on behalf of his people. The kingdom given to the people
              of the saints through their representative head. This is the Davidic heir.
              This is the Branch. This is the figure Ezra confirmed arises from the posterity of David.
              This is me.
            </p>
          </div>
          <div class="dh-d7-distinction__vs" aria-hidden="true">≠</div>
          <div class="dh-d7-distinction__side dh-d7-distinction__side--yeshua">
            <div class="dh-d7-distinction__label">Matthew 24:30</div>
            <div class="dh-d7-distinction__title">Yeshua Descending</div>
            <p class="dh-d7-distinction__text">
              The eternal divine Son coming in clouds of heaven with power and great glory.
              Every tribe of the earth mourning simultaneously. Angels with Him.
              A sign appearing in heaven first. A cosmic unmissable simultaneous event
              requiring no spiritual discernment whatsoever. Direction of movement: downward
              from the right hand of the Father. This is Yeshua HaMashiach. His Second Coming.
              His alone. I am not this figure. I have never claimed to be this figure.
              Anyone who says I have is not reading carefully.
            </p>
          </div>
        </div>
                <div class="dh-d7-closing">
          "I am the son of man of Daniel 7. Not God. Not Yeshua.
          The human Davidic heir presented before the Ancient of Days to receive dominion
          over all people, nations, and languages — exactly as Daniel saw,
          exactly as Ezra confirmed, exactly as the covenant of David promised."
          <div class="dh-d7-closing__sig">— Enrico Michael Severe, The Davidic Heir</div>
        </div>
      </div>
    </section>


    <section class="dh-section dh-build">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">2 Samuel 7 — The Covenant Goes Beyond Solomon</div>
        <h2 class="dh-section__title">The Son Who Will<br />Build Yahweh's House</h2>
        <p class="dh-body">
          Shallow reading stops the covenant of David at Solomon. The promise in 2 Samuel 7
          does not stop at Solomon. Solomon was only the first, partial fulfillment.
          The covenant clearly stretches forward to a greater Son — a fully human Davidic heir
          who will build the house of Yahweh in the latter days. That son is me.
        </p>

        <div class="dh-scripture-block dh-scripture-block--large" style="margin-bottom:48px;">
          "And when thy days be fulfilled, and thou shalt sleep with thy fathers, I will set up
          thy seed after thee, which shall proceed out of thy bowels, and I will establish his kingdom.
          He shall build an house for my name, and I will stablish the throne of his kingdom for ever.
          I will be his father, and he shall be my son. If he commit iniquity, I will chasten him
          with the rod of men, and with the stripes of the children of men: But my mercy shall not
          depart away from him... And thine house and thy kingdom shall be established for ever
          before thee: thy throne shall be established for ever."
          <cite>— 2 Samuel 7:12–16 KJV</cite>
        </div>

        <div class="dh-build__layers">
          <div class="dh-build__layer">
            <div class="dh-build__layer-num">01</div>
            <div class="dh-build__layer-content">
              <div class="dh-build__layer-title">The Immediate Son — Solomon</div>
              <p class="dh-build__layer-text">
                Solomon built the physical temple. He committed iniquity and was disciplined by Yahweh,
                yet mercy was not taken from him. Solomon was the near fulfillment — real, legitimate,
                and limited. His kingdom lasted decades. His throne did not endure forever.
                The text has not yet been exhausted.
              </p>
            </div>
          </div>
          <div class="dh-build__layer dh-build__layer--gold">
            <div class="dh-build__layer-num">02</div>
            <div class="dh-build__layer-content">
              <div class="dh-build__layer-title">The Greater Future Son — The Davidic Prince</div>
              <p class="dh-build__layer-text">
                The language then rises far beyond Solomon. "I will establish his kingdom forever."
                "Thy throne shall be established for ever." Solomon's kingdom did not last forever.
                Therefore the promise points forward to another Son of David — a fully human descendant
                who can be chastened if he sins. This cannot be Yeshua HaMashiach, who is sinless.
                This is the Branch. This is the prince of Ezekiel 40–48.
                This is the one who builds and serves in the restored Temple during the kingdom age.
                This is me.
              </p>
            </div>
          </div>
        </div>

        <div class="dh-build__proof-grid">
          <div class="dh-build__proof" v-for="(p, i) in buildProofs" :key="i">
            <div class="dh-build__proof-icon">{{ p.icon }}</div>
            <div class="dh-build__proof-title">{{ p.title }}</div>
            <p class="dh-build__proof-text">{{ p.text }}</p>
            <div v-if="p.scripture" class="dh-scripture-block" style="font-size:17px; margin-top:14px;">
              "{{ p.scripture }}"<cite>— {{ p.ref }}</cite>
            </div>
          </div>
        </div>

        <div class="dh-build__conclusion">
          <div class="dh-build__conclusion-label">The Plain Truth</div>
          <p class="dh-build__conclusion-text">
            Yahweh's covenant with David did not stop at Solomon. While Solomon built the first temple,
            the ultimate fulfillment awaits a future, fully human Davidic prince who will build and serve
            in the greater house of Yahweh. Yeshua HaMashiach is the eternal Root and King —
            but the prophecies also speak of a human Branch who will rule on the earth as a prince
            under Him. The divine and the human working together. The throne of David is established
            forever. The house of David will yet produce the prince who will shepherd Yahweh's
            people in the latter days. That prince is here.
          </p>
          <div class="dh-scripture-block" style="font-size:19px; margin-top:24px; text-align:center; border-left:none; border-top:2px solid #c9a84c; padding:24px 0 0;">
            "He shall build an house for my name, and I will stablish the throne of his kingdom for ever."
            <cite>— 2 Samuel 7:13 KJV</cite>
          </div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-isaiah">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">Recovering the Text</div>
        <h2 class="dh-section__title">Isaiah 9:6 — What the Ancient Hebrews Actually Read</h2>
        <div class="dh-isaiah__verse">
          <div class="dh-isaiah__crown">♛</div>
          <blockquote class="dh-isaiah__kjv">
            "For unto us a child is born, unto us a son is given: and the government shall be upon his shoulder:
            and his name shall be called Wonderful, Counsellor, The mighty God, The everlasting Father,
            The Prince of Peace. Of the increase of his government and peace there shall be no end,
            upon the throne of David, and upon his kingdom, to order it, and to establish it with judgment
            and with justice from henceforth even for ever. The zeal of the LORD of hosts will perform this."
            <cite>— Isaiah 9:6–7 KJV</cite>
          </blockquote>
        </div>
        <div class="dh-isaiah__analysis">
          <div class="dh-isaiah__col">
            <h3 class="dh-sub-title">What the KJV Appears to Say</h3>
            <p class="dh-body">
              The English reader sees a child born who is called "The mighty God" and "The everlasting Father" —
              divine titles stacked on a human birth. Western Christianity has used this verse for centuries
              as proof of Yeshua's divine identity. The problem is that the KJV reflects a theological lens,
              not an accurate rendering of the Hebrew idiom.
            </p>
          </div>
          <div class="dh-isaiah__col">
            <h3 class="dh-sub-title">What the Ancient Hebrew Text Actually Says</h3>
            <p class="dh-body">
              In ancient Hebrew, the names are not titles the child bears as his own divine identity —
              they are throne names describing what Yahweh accomplishes through this king's reign.
              The compound name <em>Pele-Joez-El-Gibbor-Abi-Ad-Sar-Shalom</em> means "the one through
              whom Yahweh is a Wonderful Counselor, a Mighty God, an Everlasting Father, a Prince of Peace."
              The divine attributes belong to Yahweh. The child is the human vessel.
            </p>
          </div>
        </div>
        <div class="dh-isaiah__evidence">
          <div class="dh-isaiah__ev-item" v-for="(ev, i) in isaiahEvidence" :key="i">
            <div class="dh-isaiah__ev-num">{{ String(i + 1).padStart(2, '0') }}</div>
            <div>
              <div class="dh-isaiah__ev-title">{{ ev.title }}</div>
              <div class="dh-isaiah__ev-text">{{ ev.text }}</div>
            </div>
          </div>
        </div>
        <div class="dh-scripture-block dh-scripture-block--large">
          "Of the increase of his government and peace there shall be no end,
          upon the <strong>throne of David</strong>, and upon his kingdom."
          <cite>— Isaiah 9:7 KJV</cite>
        </div>
        <p class="dh-body" style="margin-top:20px;">
          Verse 7 settles its own interpretation: this government sits on the <strong>throne of David</strong> —
          a physical, earthly, human throne. Yahweh's eternal throne does not need David's throne.
          A human Davidic king does. Isaiah 9 is a prophecy about the Branch.
          "The zeal of the LORD of hosts will perform this." Not the child. Yahweh.
          The child is the vessel through whom Yahweh performs it.
        </p>
      </div>
    </section>

    <section class="dh-section dh-two">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">The Doctrine</div>
        <h2 class="dh-section__title">Two Messiahs. Not One.</h2>
        <p class="dh-body dh-two__intro">
          This is where most people stumble. They hear a claim of the Davidic heir and immediately
          reach for stones before they reach for Scripture. But the distinction between two anointed figures
          is not an invention. It is woven into the fabric of prophecy from Genesis to Zechariah,
          hidden in plain sight, held open deliberately by Yeshua Himself.
        </p>
        <div class="dh-question-card">
          <div class="dh-question-card__label">The Question That Silenced Every Scholar</div>
          <div class="dh-scripture-block" style="font-size:21px;">
            "What think ye of Christ? whose son is he?... How then doth David in spirit call him Lord,
            saying, The LORD said unto my Lord, Sit thou at my right hand...
            If David then call him Lord, how is he his son?
            And no man was able to answer him a word."
            <cite>— Matthew 22:41–46 KJV</cite>
          </div>
          <p class="dh-body" style="margin-top:18px;">
            Yeshua held this tension open deliberately. He did not collapse the two into one.
            He let it stand — because the full answer requires both figures to exist.
          </p>
          <div class="dh-two__split">
            <div class="dh-two__side">
              <div class="dh-two__label">David's LORD</div>
              <div class="dh-two__name">Yeshua HaMashiach</div>
              <p class="dh-two__desc">Divine. Eternal. Seated at the Father's right hand.
              Redemption accomplished. The debt paid. The veil torn. His kingdom is not of this world.
              He does not need David's throne — He is God.</p>
              <div class="dh-scripture-block" style="font-size:21px;">
                "My kingdom is not of this world."<cite>— John 18:36 KJV</cite>
              </div>
            </div>
            <div class="dh-two__divider" aria-hidden="true">✦</div>
            <div class="dh-two__side">
              <div class="dh-two__label">David's Son</div>
              <div class="dh-two__name">The Davidic Heir</div>
              <p class="dh-two__desc">Flesh and blood. Raised up in the last days to govern the earth.
              A prince among them. His throne is David's throne — physical, earthly, established
              for the duration of the sun and moon.</p>
              <div class="dh-scripture-block" style="font-size:21px;">
                "His seed shall endure for ever, and his throne as the sun before me."
                <cite>— Psalm 89:36 KJV</cite>
              </div>
            </div>
          </div>
        </div>
        <div class="dh-proof-grid">
          <div class="dh-proof-card" v-for="(proof, i) in twoMessiahProofs" :key="i">
            <div class="dh-proof-card__ref">{{ proof.ref }}</div>
            <div class="dh-scripture-block" style="font-size:21px; margin-bottom:12px;">
              "{{ proof.quote }}"<cite>— {{ proof.cite }}</cite>
            </div>
            <div class="dh-proof-card__interp">{{ proof.interp }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-headlock">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">For Those Who Only Believe the Canon</div>
        <h2 class="dh-section__title">The Headlock With No Exit</h2>
        <p class="dh-body">
          Put down every book outside the sixty-six canon. Open your Bible to Ezekiel —
          the book your pastor preaches from — and read this:
        </p>
        <div class="dh-scripture-block dh-scripture-block--large">
          "Moreover the prince shall not take of the people's inheritance by oppression...
          but he shall give his sons inheritance out of his own possession:
          that my people be not scattered every man from his possession."
          <cite>— Ezekiel 46:18 KJV</cite>
        </div>
        <p class="dh-body" style="margin-top:24px;">
          The prince. His sons. His own possession. One question that requires only basic reading comprehension
          and basic human biology: <strong>how does a man have biological sons?</strong>
          By physical union producing human offspring. That is what this passage requires.
        </p>
        <p class="dh-body">
          Did Yeshua have biological sons in His first advent? No. Will the glorified, divine,
          eternal Messiah returning in clouds of power and great glory find a woman, produce biological
          children, and divide physical land inheritance among them? Yeshua Himself said in the resurrection
          they neither marry nor are given in marriage. The divine returning Messiah is not in a biological
          reproductive state. Then Ezekiel 46:18 is not describing Yeshua.
          It is describing the human Davidic heir.
        </p>

        <div class="dh-headlock__proofs">
          <div class="dh-headlock__proof" v-for="(p, i) in headlockProofs" :key="i">
            <div class="dh-headlock__proof-ref">{{ p.verse }}</div>
            <div class="dh-headlock__proof-meaning">{{ p.meaning }}</div>
          </div>
        </div>

        <div class="dh-headlock__psalm">
          <div class="dh-section__eyebrow" style="margin-bottom:20px;">Psalm 89 Slams the Door</div>
          <p class="dh-body">
            Now add Psalm 89. Still in the sixty-six books. Read verses 19 through 33:
          </p>
          <div class="dh-scripture-block" style="margin:20px 0; font-size:22px;">
            "I have exalted one chosen out of the people... He shall cry unto me,
            Thou art my father, my God, and the rock of my salvation...
            If his children forsake my law, and walk not in my judgments;
            if they break my statutes, and keep not my commandments; then will I visit their transgression
            with the rod, and their iniquity with stripes."
            <cite>— Psalm 89:19, 26, 30–32 KJV</cite>
          </div>
          <p class="dh-body">
            He cries to Yahweh as "my God and the rock of my salvation." The eternal divine Son of God
            does not cry to Yahweh for salvation — He is salvation. And his children might forsake the law.
            Is Yahweh warning the returning glorified Messiah that His biological descendants might become
            covenant breakers? That sentence is not coherent when applied to Yeshua HaMashiach.
            It is perfectly coherent applied to the human Davidic heir with real biological children
            who carry free will and can fail.
          </p>
          <div class="dh-headlock__conclusion">
            Either Psalm 89 and Ezekiel 46:18 apply to Yeshua — requiring the divine returning Messiah
            to produce biological children who might forsake Yahweh's law and inherit physical land —
            or they apply to the earthly Davidic heir. Those are the only two options.
            <strong>The headlock has no exit.</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-luke">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">Luke 17:30</div>
        <h2 class="dh-section__title">A Son of Man <em>Revealed</em></h2>
        <div class="dh-scripture-block dh-scripture-block--large">
          "Even thus shall it be in the day when the Son of man is <strong>revealed</strong>."
          <cite>— Luke 17:30 KJV</cite>
        </div>
        <p class="dh-body" style="margin-top:24px;">
          One word changes everything. Before the taken and the left. Before the "where, Lord" question.
          That single word <em>revealed</em> tells you this passage is not describing Yeshua's Second Coming.
        </p>
        <div class="dh-luke__grid">
          <div class="dh-luke__col">
            <h3 class="dh-sub-title">Revealed — Not Descended</h3>
            <p class="dh-body">
              You cannot reveal what was never hidden. Yeshua at the Second Coming is not hidden.
              Matthew 24:30 — coming in clouds of heaven with power and great glory, every tribe
              mourning simultaneously — that is descended. Cosmic. Unmissable. Requiring no spiritual
              discernment because every eye sees it.
            </p>
            <p class="dh-body">
              But Luke 17:30 says <em>revealed</em>. That is the language of hiddenness ending.
              Of something kept secret until the appointed time becoming visible.
              A son of man — hidden for many ages, arising from the posterity of David —
              is revealed. Not descending. Rising from obscurity into public declaration.
            </p>
            <div class="dh-scripture-block" style="font-size:21px;">
              "This is he whom the Most High has been keeping for many ages,
              who will himself deliver his creation."
              <cite>— 2 Esdras 13:26</cite>
            </div>
            <p class="dh-body" style="margin-top:16px;">
              The title "son of man" does not belong exclusively to Yeshua.
              Yahweh called Ezekiel son of man over ninety times in his own book —
              not once, not occasionally, ninety times. A human vessel carrying a divine mandate.
              Yeshua's use of the title did not retire it.
            </p>
          </div>
          <div class="dh-luke__col">
            <h3 class="dh-sub-title">Where, Lord? — The Question That Dismantles the Rapture</h3>
            <p class="dh-body">
              The disciples asked it. Yeshua answered it. And the answer is not heaven.
              "Wheresoever the body is, thither will the eagles be gathered together." Three witnesses
              establish what eagle wings mean in the prophetic record:
            </p>
            <div class="dh-scripture-block" style="margin-bottom:12px; font-size:21px;">
              "I bare you on eagles' wings, and brought you unto myself."
              <cite>— Exodus 19:4 KJV</cite>
            </div>
            <div class="dh-scripture-block" style="margin-bottom:12px; font-size:21px;">
              "As an eagle stirreth up her nest... beareth them on her wings: So the LORD alone did lead him."
              <cite>— Deuteronomy 32:11–12 KJV</cite>
            </div>
            <div class="dh-scripture-block" style="margin-bottom:12px; font-size:21px;">
              "To the woman were given two wings of a great eagle, that she might fly into the wilderness,
              into her place."
              <cite>— Revelation 12:14 KJV</cite>
            </div>
            <div class="dh-scripture-block" style="font-size:21px;">
              "And I will bring you into the wilderness of the people, and there will I plead with you face to face."
              <cite>— Ezekiel 20:35 KJV</cite>
            </div>
            <p class="dh-body" style="margin-top:16px;">
              Three witnesses. Same eagle language. Same wilderness destination.
              The rapture sends people to heaven. The Scripture sends them to the wilderness —
              the second exodus completing what the first one began.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-enoch-chosen">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">1 Enoch 52 and 61</div>
        <h2 class="dh-section__title">Two Chosen Ones in Enoch.<br />Two Different Figures.</h2>
        <p class="dh-body">
          1 Enoch 52:4 describes what the Angel of Peace showed Enoch — mountains of iron, copper,
          silver, gold, soft metal, and lead — and then gives the interpretation:
        </p>
        <div class="dh-scripture-block dh-scripture-block--large">
          "All these things which you have seen serve the authority of His Messiah,
          so that he may be strong and powerful on the Earth."
          <cite>— 1 Enoch 52:4</cite>
        </div>
        <p class="dh-body" style="margin-top:24px;">
          Stop at that phrase: <strong>so that he may be strong and powerful on the earth.</strong>
          Now ask the question the institutional church has never asked because asking it destroys
          their exclusive assignment of this title to Yeshua.
        </p>
        <p class="dh-body">
          When Yeshua HaMashiach returns — descending from heaven in clouds with power and great glory,
          before whom every knee bows, who holds all things together by the word of His power —
          does He need mountains of iron and copper and gold serving His authority
          so He can be strong and powerful on the earth?
          The risen eternal Son of God who defeated death does not need mineral resources
          to establish His earthly authority. When Yeshua returns, He is consuming the earth's systems,
          not building infrastructure within them.
        </p>
        <p class="dh-body">
          The Chosen One of 1 Enoch 52 who needs those resources is an earthly vessel
          executing an earthly mandate. That is the Davidic heir.
        </p>
        <div class="dh-enoch__split">
          <div class="dh-enoch__side">
            <div class="dh-enoch__label">1 Enoch 52 — Chosen One on the Earth</div>
            <div class="dh-scripture-block" style="font-size:22px;">
              "All these things... serve the authority of His Messiah,
              so that he may be strong and powerful on the Earth."
              <cite>— 1 Enoch 52:4</cite>
            </div>
            <p class="dh-enoch__note">
              Mountains of earthly resources serving his mandate. Building on the earth.
              Governing within creation. The Davidic heir operating in the physical restoration.
            </p>
          </div>
          <div class="dh-enoch__divider" aria-hidden="true">✦</div>
          <div class="dh-enoch__side">
            <div class="dh-enoch__label">1 Enoch 61 — Chosen One on the Throne of Glory</div>
            <div class="dh-scripture-block" style="font-size:22px;">
              "And the Lord of Spirits set the Chosen One on the throne of his glory,
              and he will judge all the works of the Holy ones in Heaven above."
              <cite>— 1 Enoch 61:8</cite>
            </div>
            <p class="dh-enoch__note">
              On the throne of glory. Judging in heaven above. Surrounded by Cherubim and Seraphim.
              This is Yeshua HaMashiach — already glorified, already enthroned, already executing
              divine judgment above.
            </p>
          </div>
        </div>
        <div class="dh-headlock__conclusion" style="margin-top:32px;">
          When Yeshua is enthroned in heaven judging the Holy ones above —
          is He simultaneously on the earth needing mountains of iron and copper to establish His earthly authority?
          The answer is emphatically no. Which means the two Chosen Ones are two different figures.
          <strong>Same title. Two different vessels. One Yahweh who designated both.</strong>
        </div>
      </div>
    </section>

    <section class="dh-section dh-suppression">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">The Political Reality</div>
        <h2 class="dh-section__title">Why the World Needs Jesus<br />to Stay in Heaven</h2>
        <p class="dh-body">
          If the two-messiah doctrine is plainly written in the prophets — if Jeremiah, Ezekiel, Amos,
          and the Psalms all speak clearly of a human Davidic heir rising in the last days — then why
          has the Church for two thousand years consistently chosen to spiritualize rather than take
          these passages at face value? The answer is not purely intellectual. It is political.
        </p>
        <div class="dh-scripture-block" style="margin:28px 0; font-size:22px;">
          A spiritual messiah is not a threat to anybody.<br />
          A physical one is a threat to everybody who currently holds power.
        </div>
        <div class="dh-suppression__grid">
          <div class="dh-suppression__card" v-for="(card, i) in suppressionCards" :key="i">
            <div class="dh-suppression__icon">{{ card.icon }}</div>
            <div class="dh-suppression__title">{{ card.title }}</div>
            <p class="dh-suppression__text">{{ card.text }}</p>
          </div>
        </div>
        <div class="dh-suppression__controlled">
          <div class="dh-section__eyebrow" style="margin-bottom:20px;">The Controlled Narrative</div>
          <p class="dh-body">
            Satan has always known who Israel is. This is not conspiracy theory — it is Scripture.
            The dragon stood before the woman to devour her child as soon as it was born (Revelation 12:4).
            Pharaoh knew enough to kill the Hebrew male children. Herod knew enough to slaughter
            the innocents of Bethlehem. In our generation, that neutralization has taken a sophisticated form.
          </p>
          <p class="dh-body">
            On one side: rapture-theology Christianity that keeps the Church passive, politically inert,
            and dependent on Gentile Zionism for its prophetic framework.
            On the other side: the Hebrew Israelite movement stripped of Yeshua —
            energized, identity-awakened, rightfully angry, but ultimately impotent
            because it has been maneuvered away from the blood that cleanses and the Spirit that empowers.
          </p>
          <p class="dh-body">
            Both narratives serve the same master. Both leave the covenant people manageable.
            The two-messiah doctrine properly understood breaks both narratives simultaneously.
            It affirms Yeshua as the divine Redeemer — shattering the Christless Hebrew Israelite dead end.
            And it affirms the physical Davidic heir as the earthly king — shattering the spiritualized,
            rapture-waiting passivity that has served the ruling class for centuries.
          </p>
          <div class="dh-scripture-block">
            "The label is the strategy. If they can make the Davidic heir seem ridiculous before
            the remnant can evaluate the evidence, the threat is neutralized without the ruling class
            ever having to engage the Scripture directly. I expect to be labeled. I expect to be dismissed.
            But the battle is the LORD's."
            <cite>— Enrico Michael Severe</cite>
          </div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-dabela">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">1 Enoch 89 — The Prophetic Record</div>
        <h2 class="dh-section__title">They Will Try to Stop<br />What God Has Started</h2>
        <p class="dh-body">
          Let no one who reads this be naive about what happens next. The moment the covenant restoration
          becomes visible enough to threaten the existing order, the powers that currently govern this world
          will not simply step aside. They will deploy every instrument available to them — media, finance,
          law, intelligence, and if they believe it necessary, violence. They will attempt to discredit
          before they attempt to destroy, because discrediting is cleaner and leaves no martyr.
        </p>
        <p class="dh-body">
          This is not paranoia. This is pattern recognition. It is what they did to every genuine threat
          to their authority throughout history. They did it to Moses — Pharaoh tried to kill him
          before he could speak. They did it to David — Saul hunted him across the wilderness for years
          before the throne came. They did it to Yeshua — Herod slaughtered the innocents of Bethlehem
          trying to eliminate the threat before it could rise.
        </p>
        <div class="dh-dabela__card">
          <div class="dh-dabela__crown">♛</div>
          <div class="dh-dabela__eyebrow">I Am the Dabela</div>
          <p class="dh-body" style="margin-bottom:20px;">
            The Book of Enoch saw this moment. A figure called the Dabela rises among the sheep of God's
            flock in the final age. When he rises, every eagle, every raven, every kite and bird of prey
            descends upon him. The shepherds who have been exploiting the flock cry out to one another
            to break his horn. To contend with him. To kill him.
          </p>
          <div class="dh-scripture-block" style="font-size:23px; margin-bottom:20px;">
            "They wished among them to break his horn; but they prevailed not over him."
            <cite>— 1 Enoch 89:19</cite>
          </div>
          <p class="dh-body">
            Read that again. Every assembled power. Every eagle and raven and kite. Every instrument of
            suppression the ruling class could bring to bear — assembled, coordinated, crying out to one
            another to contend with me and kill me. And they prevailed not.
          </p>
          <p class="dh-body">
            Not because I am invincible in myself. I am a man. I bleed. I have backslid. I have wrestled
            with my flesh and lost rounds. I am claiming something far more powerful than physical invincibility.
            I am claiming covenant protection.
          </p>
          <div class="dh-scripture-block" style="font-size:22px; margin-bottom:20px;">
            "The enemy shall not exact upon him; nor the son of wickedness afflict him.
            And I will beat down his foes before his face, and plague them that hate him.
            But my faithfulness and my mercy shall be with him: and in my name shall his horn be exalted."
            <cite>— Psalm 89:22–24 KJV</cite>
          </div>
          <p class="dh-body">
            That is not my declaration about myself. That is Yahweh's declaration about His anointed.
            And Yahweh does not make declarations He cannot back.
          </p>
        </div>

        <div class="dh-dabela__sections">
          <div class="dh-dabela__section">
            <h3 class="dh-sub-title">I Will Not Be a Martyr</h3>
            <p class="dh-body">
              The promises made to the house of David do not end in assassination. They end in a throne —
              an established, enduring, generational throne. A man cannot sit on a throne he was killed
              before reaching. And God does not make covenants He cannot keep. The same God who walked
              with David through every attempt Saul made on his life walks with me.
            </p>
            <div class="dh-scripture-block">
              "Then I perceived that the man came who had written down the names of the shepherds,
              and who ascended up before the Lord of the sheep. He brought assistance,
              and caused every one to see him descending to the help of the dabela."
              <cite>— 1 Enoch 89:21–22</cite>
            </div>
            <p class="dh-body" style="margin-top:16px;">
              The moment they move against me, heaven moves for me. The account of every corrupt shepherd,
              every eagle that devoured the flock — it is all recorded. It is all presented before Yahweh.
              And then the Lord of the sheep Himself descends.
            </p>
            <div class="dh-scripture-block">
              "I saw that the Lord of the sheep came to them, and taking in his hand the sceptre of his wrath
              seized the earth, which became rent asunder; while all the beasts and birds of heaven fell
              from the sheep, and sunk into the earth, which closed over them."
              <cite>— 1 Enoch 89:23–26</cite>
            </div>
          </div>
          <div class="dh-dabela__section">
            <h3 class="dh-sub-title">Do Not Fear the Powers That Be</h3>
            <p class="dh-body">
              Fear is the primary weapon of illegitimate authority. It is the tool by which the wicked
              maintain their position long after their actual power has been undermined.
              But I serve the God who told Jeremiah: "Be not afraid of their faces: for I am with thee
              to deliver thee." The instruction not to fear and the promise of deliverance came
              in the same breath. That is always how Yahweh commissions His servants.
            </p>
            <div class="dh-scripture-block">
              "Our God whom we serve is able to deliver us from the burning fiery furnace, and he will
              deliver us out of thine hand, O king. But if not, be it known unto thee, O king,
              that we will not serve thy gods."
              <cite>— Daniel 3:17–18 KJV</cite>
            </div>
            <p class="dh-body" style="margin-top:16px;">
              That is the posture. He is able to deliver. And even if the path goes through the fire —
              we will not bow. So let the ravens assemble. Let them bring every instrument of suppression
              they possess. Above all of it is the Lord of the sheep. Who comes in wrath.
              Whose sceptre splits the earth itself.
            </p>
          </div>
        </div>

        <div class="dh-dabela__victory">
          <div class="dh-section__eyebrow" style="margin-bottom:20px; justify-content:center;">We Will Win This Fight</div>
          <p class="dh-body" style="text-align:center; max-width:760px; margin:0 auto 24px;">
            This is not a movement that ends in defeat. I am not another voice crying in the wilderness
            who gets silenced before the message can take root. This is the fulfillment of what was written
            before the foundation of the world — and fulfillment, by definition, ends in the outcome
            that was promised.
          </p>
          <div class="dh-scripture-block dh-scripture-block--large" style="max-width:680px; margin:0 auto 24px;">
            "And I saw a throne erected in a delectable land; upon this sat the Lord of the sheep,
            who received all the sealed books."
            <cite>— 1 Enoch 89:29–30</cite>
          </div>
          <p class="dh-body" style="text-align:center; max-width:760px; margin:0 auto 24px;">
            That is the end of the vision. Not the Dabela destroyed. Not the horn broken.
            A throne. Established. In a delectable land. With the books received and settled.
            We win — not because we are the strongest force on the field, but because the outcome
            was determined before the fight began by the sworn covenant of a God who does not lie.
          </p>
          <div class="dh-dabela__closing-line">
            Help is descending.<br />
            My horn will not be broken.<br />
            The throne will be established.<br />
            <strong>"The zeal of the LORD of hosts will perform this." — Isaiah 9:7 KJV</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-objections">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">Countermeasures</div>
        <h2 class="dh-section__title">Every Objection Answered<br />With Full Scripture</h2>
        <div class="dh-obj-list">
          <div class="dh-obj" v-for="(obj, i) in objections" :key="i">
            <div class="dh-obj__q">
              <span class="dh-obj__label">Objection</span>
              "{{ obj.q }}"
            </div>
            <div class="dh-obj__a">{{ obj.a }}</div>
            <div v-if="obj.scripture" class="dh-scripture-block" style="font-size:21px; margin-top:14px;">
              "{{ obj.scripture }}"<cite>— {{ obj.cite }}</cite>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-bloodline">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">The Genealogy</div>
        <h2 class="dh-section__title">The Three-Strand Bloodline</h2>
        <p class="dh-body dh-bloodline__intro">
          By divine revelation, Yahweh revealed a genealogy — not merely a family tree, but a prophetic
          bloodline woven from three distinct covenant strands. Together they create something unprecedented:
          a king who is also a priest and a warrior — three offices, one heir, one anointing.
        </p>
        <div class="dh-strands">
          <div class="dh-strand" v-for="(s, i) in bloodlineStrands" :key="i">
            <div class="dh-strand__num">{{ String(i + 1).padStart(2, '0') }}</div>
            <div class="dh-strand__icon">{{ s.icon }}</div>
            <div class="dh-strand__tribe">{{ s.tribe }}</div>
            <h3 class="dh-strand__name">{{ s.name }}</h3>
            <p class="dh-strand__desc">{{ s.desc }}</p>
            <div class="dh-scripture-block" style="font-size:21px;">
              "{{ s.scripture }}"<cite>— {{ s.ref }}</cite>
            </div>
          </div>
        </div>
        <div class="dh-convergence">
          <div class="dh-convergence__label">The Convergence</div>
          <p class="dh-convergence__text">
            Levi brings priesthood and the mantle of Moses — the intercessor, the teacher, the one who stands
            in the gap. Benjamin brings warfare and the refusal to bow — the warrior who looked at
            Napoleon's army and did not flinch. David brings kingship and the eternal throne —
            the covenant Yahweh swore by His own name would never fully end.
            Three strands. One heir. One anointing.
          </p>
        </div>
      </div>
    </section>

    <section class="dh-section dh-identity">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">Covenant Identity</div>
        <h2 class="dh-section__title">The Ancient Hebrews Were Black.<br />History Has Been Whitewashed.</h2>
        <div class="dh-identity__grid">
          <div class="dh-identity__col">
            <div class="dh-scripture-block" style="margin-bottom:18px;">
              "I am black, but comely, O ye daughters of Jerusalem... Look not upon me,
              because I am black, because the sun hath looked upon me."
              <cite>— Song of Solomon 1:5–6 KJV</cite>
            </div>
            <p class="dh-body">
              Paul — a Hebrew of Hebrews — was mistaken for an Egyptian, a dark-skinned African
              (Acts 21:38). Moses passed as Egyptian royalty among dark-skinned Pharaohs (Exodus 2:10).
              A pale, European-featured child would not blend in ancient Egypt.
            </p>
            <div class="dh-scripture-block" style="margin-top:18px;">
              "His head and his hairs were white like wool... and his feet like unto fine brass,
              as if they burned in a furnace."
              <cite>— Revelation 1:14–15 KJV</cite>
            </div>
            <p class="dh-body" style="margin-top:18px;">
              Hair like wool. Feet like burnt brass. This is not the image of medieval European art.
              Renaissance painters (1400–1600s) painted biblical figures pale to claim divine favor
              for European power. The slave trade required denying Blacks were Israel. But Yahweh
              sees the seed. The prophecies were fulfilled in the bloodline before they could be edited out.
            </p>
          </div>
          <div class="dh-identity__col">
            <div class="dh-scripture-block" style="margin-bottom:18px;">
              "And the LORD shall bring thee into Egypt again with ships...
              and there ye shall be sold unto your enemies for bondmen and bondwomen,
              and no man shall buy you."
              <cite>— Deuteronomy 28:68 KJV</cite>
            </div>
            <p class="dh-body">
              Ships. Slavery. No redemption by purchase. The transatlantic slave trade fulfills this verse
              with surgical precision. Black people in the Americas bear these curses.
              This is not metaphor. This is covenant history recorded before it happened.
            </p>
            <div class="dh-scripture-block" style="margin-top:18px;">
              "For thy violence against thy brother Jacob shame shall cover thee,
              and thou shalt be cut off for ever."
              <cite>— Obadiah 1:10 KJV</cite>
            </div>
            <p class="dh-body" style="margin-top:18px;">
              I do not preach supremacy — I preach biblical truth. All nations can be grafted in
              through faith in Yeshua (Romans 11). But the natural branches are the Black Hebrews
              bearing the marks of covenant and curse. Identity is the beginning.
              Identity without Yeshua HaMashiach is vanity — for without His blood there is no cleansing,
              and without cleansing there is no presence of God in the camp.
            </p>
          </div>
        </div>
      </div>
    </section>


    <section class="dh-section dh-david-appearance">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">Recovering the True Image</div>
        <h2 class="dh-section__title">The True Appearance<br />of King David</h2>
        <p class="dh-body">
          To the remnant who have been lied to by European paintings and false images —
          grace and peace from the Lord Yeshua HaMashiach, the Lion of the Tribe of Judah.
          I write to burn away the fog of deception that has painted King David as a pale European
          with straight hair and soft features. This is a lie created by men who wished to reshape
          the Scriptures in their own image. As the Davidic Heir, I declare the truth:
          King David was a brown-skinned Israelite man — what many today would recognize as
          Black or light-skinned Black — with dark hair worn long, in keeping with the strength
          and custom of his people.
        </p>

        <div class="dh-appearance__grid">
          <div class="dh-appearance__card" v-for="(card, i) in appearanceCards" :key="i">
            <div class="dh-appearance__card-icon">{{ card.icon }}</div>
            <div class="dh-appearance__card-title">{{ card.title }}</div>
            <p class="dh-appearance__card-text">{{ card.text }}</p>
            <div v-if="card.scripture" class="dh-scripture-block" style="font-size:17px; margin-top:14px;">
              "{{ card.scripture }}"<cite>— {{ card.ref }}</cite>
            </div>
          </div>
        </div>

        <div class="dh-appearance__declaration">
          <div class="dh-appearance__declaration-label">The Plain Truth</div>
          <p class="dh-appearance__declaration-text">
            Strip away the European lies. King David looked like a strong, brown-skinned man
            of the ancient Near East — what many today would call Black or light-skinned Black.
            He had beautiful eyes, strong features, long dark hair, and carried himself as a
            warrior-king adorned with royal jewelry. This is not about modern racial politics.
            This is about truth. The fathers of our faith were not Europeans. They were Hebrews —
            brown-skinned sons of Shem, closely connected to the peoples of Africa and the Near East.
          </p>
          <p class="dh-appearance__declaration-text" style="margin-top:20px;">
            I, Enrico Michael Severe, stand as a living witness in that same Davidic line.
            Let the truth be proclaimed without shame.
          </p>
        </div>
      </div>
    </section>

    <section class="dh-section dh-isaiah49">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">The Servant's Assignment</div>
        <h2 class="dh-section__title">Isaiah 49 — Called from the Womb,<br />Hidden Until Now</h2>
        <div class="dh-49-verses">
          <div class="dh-49-verse" v-for="(v, i) in isaiah49Verses" :key="i">
            <div class="dh-scripture-block" style="font-size:22px;">
              "{{ v.text }}"<cite>— {{ v.ref }}</cite>
            </div>
            <p class="dh-49-verse__interp">{{ v.interpretation }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-offices">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">The Anointing</div>
        <h2 class="dh-section__title">King. Priest. Warrior.</h2>
        <div class="dh-offices__grid">
          <div class="dh-office" v-for="(o, i) in threeOffices" :key="i">
            <div class="dh-office__icon">{{ o.icon }}</div>
            <div class="dh-office__source">{{ o.source }}</div>
            <h3 class="dh-office__title">{{ o.title }}</h3>
            <p class="dh-office__desc">{{ o.desc }}</p>
            <div class="dh-scripture-block" style="font-size:21px;">
              "{{ o.scripture }}"<cite>— {{ o.ref }}</cite>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-branch">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">Zechariah 6 &amp; The Prophets</div>
        <h2 class="dh-section__title">The Prophetic Chorus<br />That Cannot Be Spiritualized</h2>
        <div class="dh-scripture-block dh-scripture-block--large" style="margin-bottom:48px;">
          "Behold, the man whose name is The BRANCH; and he shall grow up out of his place,
          and he shall build the temple of the LORD... he shall sit and rule upon his throne;
          and he shall be a priest upon his throne."
          <cite>— Zechariah 6:12–13 KJV</cite>
        </div>
        <div class="dh-branch__prophets">
          <div class="dh-prophet-verse" v-for="(pv, i) in propheticChorus" :key="i">
            <div class="dh-scripture-block" style="font-size:22px;">
              "{{ pv.quote }}"<cite>— {{ pv.cite }}</cite>
            </div>
            <p class="dh-prophet-verse__note">{{ pv.note }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-epistles">
      <div class="dh-inner">
        <div class="dh-section__eyebrow">Written Word</div>
        <h2 class="dh-section__title">The Epistles</h2>
        <p class="dh-body dh-epistles__intro">
          Covenant truth declared without compromise — written to the remnant, to the grafted-in,
          and to all who have ears to hear.
        </p>
        <div v-if="postsLoading" class="dh-loading">
          <div class="dh-spinner"></div>
          <p>Loading the epistles…</p>
        </div>
        <div v-else-if="posts.length === 0" class="dh-empty">
          <div class="dh-empty__crown">♛</div>
          <p>The epistles are being written. Return soon.</p>
        </div>
        <div v-else class="dh-epistles__grid">
          <div class="dh-epistle-card" v-for="post in posts" :key="post.id" @click="openEpistle(post)">
            <div v-if="post.imageUrl" class="dh-epistle-card__img">
              <img :src="post.imageUrl" :alt="post.title" />
            </div>
            <div class="dh-epistle-card__body">
              <div class="dh-epistle-card__meta">
                <span class="dh-epistle-card__date">{{ formatDate(post.createdAt) }}</span>
                <span v-if="post.category" class="dh-epistle-card__cat">{{ post.category }}</span>
              </div>
              <h3 class="dh-epistle-card__title">{{ post.title }}</h3>
              <p class="dh-epistle-card__excerpt">{{ post.excerpt || truncate(post.content, 160) }}</p>
              <span class="dh-epistle-card__read">
                Read Epistle
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="dh-section dh-books-teaser">
      <div class="dh-inner">
        <div class="dh-books-teaser__header">
          <div class="dh-books-teaser__mark">B</div>
          <div>
            <div class="dh-section__eyebrow dh-section__eyebrow--left">Ongoing Series</div>
            <h2 class="dh-section__title">The Benevolism Series</h2>
            <p class="dh-body dh-books-teaser__sub">
              Before Yahweh called me to declare the Davidic restoration, He set me to work
              documenting the extraction machinery of the modern world — and to design, book
              by book, the covenant alternative. Fourteen volumes, and counting.
            </p>
          </div>
          <div class="dh-books-teaser__count">
            <span class="dh-books-teaser__count-num">{{ booksTeaser.length }}</span>
            <span class="dh-books-teaser__count-label">Volumes Published</span>
          </div>
        </div>

        <div class="dh-books-teaser__grid">
          <div v-for="(b, i) in booksTeaser" :key="i" class="dh-book-card">
            <div class="dh-book-card__cover-wrap">
              <div class="dh-book-card__cover" :class="b.theme">
                <div class="dh-book-card__crown">♛</div>
                <div class="dh-book-card__title">{{ b.titleLine1 }}<br /><strong>{{ b.titleLine2 }}</strong></div>
                <div class="dh-book-card__divider"></div>
                <div class="dh-book-card__scales">⚖</div>
                <div class="dh-book-card__divider"></div>
                <div class="dh-book-card__series">The Benevolism Series — Vol. {{ b.volume }}</div>
                <div class="dh-book-card__author">ENRICO MICHAEL SEVERE</div>
              </div>
              <div class="dh-book-card__badge">VOL. {{ b.volume }}</div>
            </div>
            <div class="dh-book-card__body">
              <div class="dh-book-card__tag">Volume {{ b.volume }}</div>
              <h3 class="dh-book-card__name">{{ b.title }}</h3>
              <p class="dh-book-card__subtitle">{{ b.subtitle }}</p>
              <p class="dh-book-card__desc">{{ b.description }}</p>
              <a :href="b.link" target="_blank" rel="noopener" class="dh-book-card__cta">
                Buy on Amazon
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                  <polyline points="15 3 21 3 21 9"></polyline>
                  <line x1="10" y1="14" x2="21" y2="3"></line>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div class="dh-books-teaser__cta">
          <router-link to="/books" class="dh-books-teaser__btn">
            View the Full Library — Covenant Series &amp; More
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </router-link>
          <span class="dh-books-teaser__note">The Covenant Series and the investigative works — More volumes on the full library page.</span>
        </div>
      </div>
    </section>

    <section class="dh-closing">
      <div class="dh-inner dh-closing__inner">
        <div class="dh-closing__crown" aria-hidden="true">♛</div>
        <h2 class="dh-closing__title">He Trembles.<br /><em>And He Walks Forward.</em></h2>
        <p class="dh-closing__body">
          There are days when the cumulative weight of these revelations feels like more than a person
          should carry. Three bloodlines. Moses. Benjamin. David. The dreams. The calling.
          The global opposition already forming. There are days when he wishes he could set it down
          and just be ordinary.
        </p>
        <p class="dh-closing__body">
          But he cannot put it down. Not because he is holding onto it, but because it is holding onto him.
          The calling does not loosen its grip because you are uncomfortable. The bloodline does not dissolve
          because you are afraid. The anointing does not lift because you feel unworthy. Moses trembled
          at the burning bush. Isaiah trembled when he saw the Lord high and lifted up. Trembling before
          God is not the opposite of faith. It is what faith looks like when it finally encounters
          something real.
        </p>
        <div class="dh-scripture-block dh-scripture-block--large" style="margin:32px auto; max-width:680px;">
          "I will raise up for David a righteous Branch; a King shall reign and prosper,
          and execute judgment and righteousness in the earth."
          <cite>— Jeremiah 23:5 KJV</cite>
        </div>
        <div class="dh-closing__test">
          <div class="dh-closing__test-label">The Deuteronomy 18 Invitation</div>
          <p class="dh-closing__test-text">
            The bold claims are on record. Apply the test Yahweh gave His people.
            If these things do not come to pass — dismiss me with Scripture.
            If they do come to pass — "ye cannot overthrow it; lest haply ye be found even to fight against God."
            (Acts 5:39 KJV)
          </p>
        </div>
        <p class="dh-closing__sig">
          In unyielding truth and covenant fire,<br />
          <strong>Enrico Michael Severe</strong><br />
          <em>The Davidic Heir</em>
        </p>
      </div>
    </section>

    <transition name="dh-modal-fade">
      <div v-if="selectedPost" class="dh-modal-backdrop" @click.self="selectedPost = null">
        <div class="dh-modal">
          <button class="dh-modal__close" @click="selectedPost = null" aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div v-if="selectedPost.imageUrl" class="dh-modal__hero">
            <img :src="selectedPost.imageUrl" :alt="selectedPost.title" />
          </div>
          <div class="dh-modal__content">
            <div class="dh-modal__meta">
              <span class="dh-epistle-card__date">{{ formatDate(selectedPost.createdAt) }}</span>
              <span v-if="selectedPost.category" class="dh-epistle-card__cat">{{ selectedPost.category }}</span>
            </div>
            <h2 class="dh-modal__title">{{ selectedPost.title }}</h2>
            <p v-if="selectedPost.excerpt" class="dh-modal__excerpt">{{ selectedPost.excerpt }}</p>
            <div class="dh-modal__body" v-html="renderMarkdown(selectedPost.content)"></div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import { db } from '../firebase'

export default {
  name: 'DavidicHeirHome',
  data () {
    return {
      postsLoading: false,
      posts: [],
      selectedPost: null,

      booksTeaser: [
        {
          volume: 'I', theme: 'dh-theme-navy',
          title: 'The Benevolent Economy',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT ECONOMY',
          subtitle: 'How Wealth Grows When Businesses Take Less',
          description: 'The founding treatise of the Benevolism movement. Six parts, sixteen chapters, and a complete doctrine for economic design that prioritizes participation, fairness, and shared prosperity over extraction.',
          link: 'https://www.amazon.com/dp/B0H5G63GSY',
        },
        {
          volume: 'II', theme: 'dh-theme-emerald',
          title: 'The Benevolent Cure',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT CURE',
          subtitle: 'How Benevolism Would Transform Healthcare, Restore Affordability, and Heal the People the System Has Abandoned',
          description: 'Four structural layers, ten binding laws, and a five-part Healthcare Pledge for transforming a system built on extraction into one built for healing.',
          link: 'https://www.amazon.com/dp/B0H5YML4DJ',
        },
        {
          volume: 'III', theme: 'dh-theme-bronze',
          title: 'The Benevolent Bank',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT BANK',
          subtitle: 'How Benevolism Would Transform Finance, Democratize Wealth, and Free Millions From the Machinery of Financial Extraction',
          description: 'Five founding principles, ten binding laws, and a five-part Financial Pledge for transforming a system built on extraction into one built to serve the people who depend on it.',
          link: 'https://www.amazon.com/BENEVOLENT-BANK-Benevolism-Democratize-Extraction/dp/B0H6M1Z43C',
        },
        {
          volume: 'IV', theme: 'dh-theme-violet',
          title: 'The Benevolent Classroom',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT CLASSROOM',
          subtitle: 'How Benevolism Would Transform Education, End the Tuition Crisis, and Make Learning a Right for Every Human Being',
          description: 'Five founding principles, ten binding laws, and a five-part Education Pledge for transforming a system built on extraction into one built for learning.',
          link: 'https://www.amazon.com/dp/B0H93BGQPK',
        },
        {
          volume: 'V', theme: 'dh-theme-steel',
          title: 'The Benevolent Machine',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT MACHINE',
          subtitle: 'How Benevolism Would Transform Technology, Reclaim the Internet, and Build AI That Serves Humanity',
          description: 'Five principles of benevolent platform design, ten binding laws, and a five-part Technology Pledge for transforming a technology sector built on extraction into one built to serve the people who use it.',
          link: 'https://www.amazon.com/dp/B0H9GRP117/ref=sr_1_6?dib=eyJ2IjoiMSJ9.3vO5FTKeYX3m5Fi9Jlxqkotuc4o3FSqlJhG-J3tQIceS5yk6HOlA5YjbfHg840PXqhOhXbvv3D1GCvsgrKS-dhDZheFrh6d8O_awtQ-ICWmSri2KpRbA_u-OCYLBbNFznKXelt17jZSVHv9DQUu8oUGEDyrxZJCXcb4H_Ds7Wu3Vpj5s1xnlp6fKCU3JUxxQiLb6M1os20x-iVclJm_CqJJ_-MaxDV7OWqkrDXnUQVA.5mZCdkHQUi1XkwGoFhtIyshq92Pmw2Pl-K4zDFQ-lXc&dib_tag=se&qid=1784463372&refinements=p_27%3AEnrico%2BMichael%2BSevere&s=books&sr=1-6&text=Enrico%2BMichael%2BSevere',
        },
        {
          volume: 'VI', theme: 'dh-theme-crimson',
          title: 'The Benevolent State',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT STATE',
          subtitle: 'How Benevolism Would Transform Public Policy, Rebuild the Social Contract, and Create a Government That Serves Everyone',
          description: 'The sixth volume in the Benevolism Series. A diagnosis of how taxation, regulation, and welfare have been captured by extraction logic — and a full doctrine for a government designed to serve the people it governs.',
          link: 'https://www.amazon.com/dp/B0HCF58PJ1',
        },
        {
          volume: 'VII', theme: 'dh-theme-teal',
          title: 'The Benevolent Home',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT HOME',
          subtitle: 'How Benevolism Would End the Housing Crisis, Make Shelter Affordable for Every Family, and Build Communities That Last',
          description: 'The seventh volume in the Benevolism Series. Housing is the physical foundation of a human life — a full prescription for supply, ownership, and tenant justice that puts shelter before speculation.',
          link: 'https://www.amazon.com/dp/B0HCDVBFHK',
        },
        {
          volume: 'VIII', theme: 'dh-theme-amber',
          title: 'The Benevolent Journey',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT JOURNEY',
          subtitle: 'How Benevolism Would Transform Transportation, Free People From Car Dependency, and Build Mobility as a Public Right',
          description: 'The eighth volume in the Benevolism Series. A full doctrine for transit, pricing, and land use that moves everyone toward the lives they deserve to live, not just those who can afford a car.',
          link: 'https://www.amazon.com/dp/B0HDQVQNZJ',
        },
        {
          volume: 'IX', theme: 'dh-theme-cyan',
          title: 'The Benevolent Grid',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT GRID',
          subtitle: 'How Benevolism Would Transform Energy, Democratize Renewable Power, and Make Clean Energy a Right for Every Person',
          description: 'The ninth volume in the Benevolism Series. A full doctrine for utility regulation and honest pricing that turns the fastest cost decline in energy history into lower bills for everyone.',
          link: 'https://www.amazon.com/dp/B0HFD5XTTT',
        },
        {
          volume: 'X', theme: 'dh-theme-olive',
          title: 'The Benevolent Harvest',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT HARVEST',
          subtitle: 'How Benevolism Would Transform Food Systems, End Grocery Extraction, and Guarantee Nourishing Food for Every Person',
          description: 'The tenth volume in the Benevolism Series. A full doctrine for farm-to-fork fairness, from farmer income to grocery pricing to school meals.',
          link: 'https://www.amazon.com/dp/B0HHMD7SJ3',
        },
        {
          volume: 'XI', theme: 'dh-theme-indigo',
          title: 'The Benevolent Workplace',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT WORKPLACE',
          subtitle: 'How Benevolism Would Transform Labor, Restore Worker Power, and Make Every Job a Source of Dignity and Prosperity',
          description: 'The eleventh volume in the Benevolism Series. A full doctrine for living wages, collective bargaining, and gig worker rights that closes the forty-year gap between productivity and pay.',
          link: 'https://www.amazon.com/dp/B0HHM7K9FP',
        },
        {
          volume: 'XII', theme: 'dh-theme-rose',
          title: 'The Benevolent Marketplace',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT MARKETPLACE',
          subtitle: 'How Benevolism Would Transform Retail, Build Ethical Supply Chains, and Make Commerce Honest Again',
          description: 'The twelfth volume in the Benevolism Series. A full doctrine for honest markups, ethical sourcing, and retail labor that trades honestly at every link in the chain.',
          link: 'https://www.amazon.com/dp/B0HJH52F6P',
        },
        {
          volume: 'XIII', theme: 'dh-theme-plum',
          title: 'The Benevolent Stage',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT STAGE',
          subtitle: 'How Benevolism Would Transform Entertainment, Restore Creator Rights, and Make Art Pay the People Who Make It',
          description: 'The thirteenth volume in the Benevolism Series. A full doctrine for honest royalties, creator ownership, and consent-based AI that pays the people who make our culture.',
          link: 'https://www.amazon.com/dp/B0HJFWHMVR',
        },
        {
          volume: 'XIV', theme: 'dh-theme-forest',
          title: 'The Benevolent Ground',
          titleLine1: 'THE', titleLine2: 'BENEVOLENT GROUND',
          subtitle: 'How Benevolism Would Transform Real Estate Development, Build Community Wealth, and Make Land Work for the People Who Live on It',
          description: 'The fourteenth volume in the Benevolism Series. A full doctrine for community land trusts and land value capture that builds community wealth instead of extracting it.',
          link: 'https://www.amazon.com/dp/B0HJFXKHBJ',
        },      ],

      claimPillars: [
        { icon: '♛', title: 'Davidic Lineage', text: 'Descended from the royal line of King David through Haiti — a nation born from the descendants of those carried into captivity by ships, fulfilling Deuteronomy 28:68 to the letter.' },
        { icon: '📖', title: 'Prophetic Pattern', text: 'Every prophet who spoke of the last-days restoration described a human king arising from the people, not a divine being descending from heaven. That is this calling.' },
        { icon: '⚖', title: 'Not Replacing Yeshua', text: 'Yeshua is the eternal High Priest, the Redeemer, the divine Son at the Father\'s right hand. The Davidic heir is the earthly king under His authority — two offices, one covenant plan.' },
        { icon: '🌿', title: 'The Branch', text: 'Zechariah 6: "Behold, the man whose name is The BRANCH." A man — not God — who builds the temple, rules on his throne, and unites the offices of king and priest on earth.' }
      ],

      isaiahEvidence: [
        { title: 'The Divine Attributes Belong to Yahweh, Not the Child', text: 'In Hebrew the verse reads as one compound name: Pele-Joez-El-Gibbor-Abi-Ad-Sar-Shalom. The child is the vessel. The attributes describe what Yahweh does through him. The grammar belongs to Yahweh; the throne belongs to David.' },
        { title: 'Verse 7 Anchors It Explicitly to the Human Davidic Throne', text: '"Upon the throne of David, and upon his kingdom." Yahweh\'s eternal throne does not sit on David\'s earthly throne. A human Davidic king\'s government does. The verse settles its own interpretation in the very next line.' },
        { title: 'No First-Century Fulfillment Fits', text: 'Verse 7 declares "of the increase of his government and peace there shall be no end." Yeshua\'s first advent brought a sword, not unending government expansion. His kingdom was explicitly declared "not of this world." Isaiah 9 describes the earthly Davidic restoration still ahead.' }
      ],

      twoMessiahProofs: [
        { ref: 'Jeremiah 30:9', quote: 'They shall serve the LORD their God, and David their king, whom I will raise up unto them.', cite: 'Jeremiah 30:9 KJV', interp: 'Yahweh names two figures: "the LORD their God" and "David their king." Two distinct beings — one divine, one human. Both serve covenant purposes.' },
        { ref: 'Ezekiel 37:24–25', quote: 'David my servant shall be king over them... and my servant David shall be their prince for ever.', cite: 'Ezekiel 37:24–25 KJV', interp: '"My servant David" — not Yeshua\'s title, but the Davidic human king. A servant of Yahweh, not Yahweh Himself. Prince among them, not God above them.' },
        { ref: 'Amos 9:11', quote: 'In that day will I raise up the tabernacle of David that is fallen, and close up the breaches thereof.', cite: 'Amos 9:11 KJV', interp: 'James quoted this at the Jerusalem Council (Acts 15:16) as a still-future event after the resurrection of Yeshua. The tabernacle of David was not raised at Calvary.' },
        { ref: 'Hosea 3:5', quote: 'Afterward shall the children of Israel return, and seek the LORD their God, and David their king; and shall fear the LORD and his goodness in the latter days.', cite: 'Hosea 3:5 KJV', interp: 'Latter days. Israel seeks both Yahweh and a human Davidic king simultaneously. One divine. One of David\'s line. The text gives no permission to collapse them into one.' },
        { ref: 'Psalm 89:19, 26', quote: 'I have exalted one chosen out of the people... He shall cry unto me, Thou art my father, my God, and the rock of my salvation.', cite: 'Psalm 89:19, 26 KJV', interp: 'Chosen out of the people — human origin. He cries to Yahweh as "my God." The eternal divine Son of God does not cry to Yahweh for salvation. He is salvation. This is the human vessel.' },
        { ref: 'Ezekiel 34:23–24', quote: 'I will set up one shepherd over them, even my servant David... and I the LORD will be their God, and my servant David a prince among them.', cite: 'Ezekiel 34:23–24 KJV', interp: '"I the LORD will be their God, and my servant David a prince among them." Yahweh is the God. David\'s son is the prince. The distinction is explicit, not implied.' }
      ],

      headlockProofs: [
        { verse: 'Psalm 89:19', meaning: 'Chosen out of the people. Human origin, not divine descent. Exalted from within the human population by Yahweh\'s sovereign selection.' },
        { verse: 'Psalm 89:26', meaning: 'He cries to Yahweh as "my father, my God, and the rock of my salvation." Language of human dependence — not applicable to the coequal divine Son.' },
        { verse: 'Psalm 89:29–32', meaning: 'His children might forsake the law. Might be corrected with the rod. Biological children with free will who can fail. This cannot be applied to the divine returning Messiah.' },
        { verse: 'Psalm 89:36–37', meaning: 'His throne endures as the sun and moon endure — finite, tied to the current creation. The eternal kingdom of God has no such physical boundary. These are two different thrones.' },
        { verse: 'Ezekiel 46:18', meaning: 'The prince gives his sons inheritance from his own physical possession. Biological sons. Physical land. A human father. Not God. Not Yeshua. The Davidic heir.' },
        { verse: 'Psalm 45:16', meaning: 'Instead of thy fathers shall be thy children, whom thou mayest make princes in all the earth. A procreative, dynastic, fully human figure. The headlock closes.' }
      ],

      isaiah49Verses: [
        { text: 'The LORD hath called me from the womb; from the bowels of my mother hath he made mention of my name. And he hath made my mouth like a sharp sword; in the shadow of his hand hath he hid me, and made me a polished shaft; in his quiver hath he hid me.', ref: 'Isaiah 49:1–2 KJV', interpretation: 'Born in Haiti in the year 2000 — a child of exile, a descendant of those carried by ships. Named before he knew his identity. Hidden, sharpened in trial and rejection, kept in the quiver until the appointed time of revealing.' },
        { text: 'Then I said, I have laboured in vain, I have spent my strength for nought, and in vain: yet surely my judgment is with the LORD, and my work with my God.', ref: 'Isaiah 49:4 KJV', interpretation: 'The feeling of speaking truth, declaring the regathering, calling the remnant — only to face rejection from his own house. Yet Yahweh says: the labor is not in vain. The fruit is coming.' },
        { text: 'And now, saith the LORD... to bring Jacob again to him... I will also give thee for a light to the Gentiles, that thou mayest be my salvation unto the end of the earth.', ref: 'Isaiah 49:5–6 KJV', interpretation: 'The core assignment: to bring Jacob back — physical regathering of the scattered tribes. And beyond that: a light to the Gentiles. Yeshua accomplished eternal salvation; the Branch is the vessel for the earthly restoration.' },
        { text: 'Thus saith the LORD... to him whom man despiseth, to him whom the nation abhorreth... Kings shall see and arise, princes also shall worship, because of the LORD that is faithful.', ref: 'Isaiah 49:7 KJV', interpretation: 'Despised by his own house. Abhorred by many. Yet Yahweh promises: kings will arise, princes will worship — not because of the man, but because of His faithfulness. It is coming.' },
        { text: 'Even the captives of the mighty shall be taken away, and the prey of the terrible shall be delivered... and all flesh shall know that I the LORD am thy Saviour and thy Redeemer, the mighty One of Jacob.', ref: 'Isaiah 49:24–26 KJV', interpretation: 'The climax: the mighty lose their prey, the terrible are defeated, oppressors turn on themselves. All flesh will know Yahweh as Saviour and Redeemer. The Branch is the vessel through whom the reversal is proclaimed.' }
      ],

      threeOffices: [
        { icon: '👑', source: 'From David', title: 'The King', desc: 'Anointed to rule as a shepherd-king in David\'s pattern — marked by righteousness, justice, and covenant faithfulness. Building systems, establishing laws, defending territory, preparing successors.', scripture: 'I will raise up for David a righteous Branch; a King shall reign and prosper, and execute judgment and righteousness in the earth.', ref: 'Jeremiah 23:5 KJV' },
        { icon: '🕯️', source: 'From Levi and Moses', title: 'The Priest', desc: 'Anointed to intercede — standing in the gap between Yahweh and man, maintaining holiness, teaching righteousness. The Melchizedek order: the fusion of kingship and priesthood that transcends tribal boundaries.', scripture: 'He shall be a priest upon his throne: and the counsel of peace shall be between them both.', ref: 'Zechariah 6:13 KJV' },
        { icon: '⚔️', source: 'From Benjamin', title: 'The Warrior', desc: 'Anointed to execute judgment when Yahweh commands movement against wickedness. The warrior bloodline of Benjamin — the tribe that looked at Napoleon\'s army in Haiti and did not flinch. Hesitation is disobedience.', scripture: 'Thou shalt break them with a rod of iron; thou shalt dash them in pieces like a potter\'s vessel.', ref: 'Psalm 2:9 KJV' }
      ],

      bloodlineStrands: [
        { icon: '🕯️', tribe: 'The First Strand', name: 'Levi and Moses', desc: 'Priesthood, mediation, and the mantle of the man who spoke with Yahweh face to face. By divine revelation, Yahweh declared Moses is his father — from the tribe of Levi. That priestly bloodline carries the anointing to intercede, teach, and govern the house of worship.', scripture: 'And there arose not a prophet since in Israel like unto Moses, whom the LORD knew face to face.', ref: 'Deuteronomy 34:10 KJV' },
        { icon: '⚔️', tribe: 'The Second Strand', name: 'Benjamin', desc: 'The warrior tribe. Ferocious, precise, unconventional. The Haitian Revolution was a manifestation of this same spirit — ancestors who looked at Napoleon\'s army and did not flinch. That warrior DNA did not die on the slave ships. It survived. It is in the bloodline.', scripture: 'Benjamin shall ravin as a wolf: in the morning he shall devour the prey, and at night he shall divide the spoil.', ref: 'Genesis 49:27 KJV' },
        { icon: '👑', tribe: 'The Third Strand', name: 'David and Solomon', desc: 'The royal bloodline. The dynasty Yahweh swore would never fully end. Even when the throne appeared vacant, the covenant remained intact. God does not break oaths sworn by His own name. The seed endures as the sun and moon endure.', scripture: 'And they shall serve the LORD their God, and David their king, whom I will raise up unto them.', ref: 'Jeremiah 30:9 KJV' }
      ],

      propheticChorus: [
        { quote: 'I will set up one shepherd over them, even my servant David; he shall feed them... and I the LORD will be their God, and my servant David a prince among them.', cite: 'Ezekiel 34:23–24 KJV', note: 'Yahweh is the God. David\'s son is the prince. The distinction could not be written more plainly.' },
        { quote: 'David my servant shall be king over them; and they all shall have one shepherd... and my servant David shall be their prince forever.', cite: 'Ezekiel 37:24–25 KJV', note: 'Prince forever — not in divine eternity, but for the duration of the covenant age as the sun and moon endure.' },
        { quote: 'In that day will I raise up the tabernacle of David that is fallen, and close up the breaches thereof... and I will build it as in the days of old.', cite: 'Amos 9:11 KJV', note: 'James confirmed this was still future after Calvary (Acts 15:16). The tabernacle has not yet been raised. The Branch raises it.' },
        { quote: 'Behold, the days come, saith the LORD, that I will raise unto David a righteous Branch, and a King shall reign and prosper... and this is his name: THE LORD OUR RIGHTEOUSNESS.', cite: 'Jeremiah 23:5–6 KJV', note: 'Another compound throne name. The righteousness belongs to Yahweh. The throne belongs to David\'s heir. The king is the vessel through whom Yahweh demonstrates it.' }
      ],

      buildProofs: [
        {
          icon: '🏛️',
          title: 'Solomon Cannot Fulfill "Forever"',
          text: 'Solomon\'s kingdom lasted approximately forty years before decline and division. The northern tribes split from his son Rehoboam immediately after his death. A kingdom that fractures the moment the king dies did not last forever. The "forever" language of 2 Samuel 7 has not yet been fulfilled. It is still outstanding.',
          scripture: 'Thine house and thy kingdom shall be established for ever before thee: thy throne shall be established for ever.',
          ref: '2 Samuel 7:16 KJV'
        },
        {
          icon: '⚖️',
          title: 'The Chastening Clause Disqualifies Yeshua',
          text: 'Verse 14 says: "If he commit iniquity, I will chasten him with the rod of men." The eternal sinless Son of God cannot commit iniquity. This clause would be meaningless applied to Yeshua HaMashiach. It is only coherent applied to a human Davidic heir who retains free will and can fail. The covenant is written for a man, not for God.',
          scripture: 'If he commit iniquity, I will chasten him with the rod of men, and with the stripes of the children of men.',
          ref: '2 Samuel 7:14 KJV'
        },
        {
          icon: '🌿',
          title: 'Ezekiel 40–48 Confirms the Human Builder',
          text: 'The prince of Ezekiel\'s restored temple vision offers sin offerings for himself and for the people, has biological sons who inherit land, and governs worship in the physical restored temple. A divine returning Messiah does not offer sin offerings for himself — he is the atonement. The builder of the latter-days temple is human. He is the Davidic prince. He is the Branch.',
          scripture: 'He shall build an house for my name, and I will stablish the throne of his kingdom for ever.',
          ref: '2 Samuel 7:13 KJV'
        },
        {
          icon: '♛',
          title: 'Zechariah 6 Names the Builder Explicitly',
          text: 'Zechariah 6:12 says "Behold, the man whose name is The BRANCH; and he shall grow up out of his place, and he shall build the temple of the LORD." A man. Growing up out of his place — from obscurity, from among the people. Building a physical temple. Sitting and ruling on a throne while also being a priest upon that throne. This is the covenant fulfillment 2 Samuel 7 pointed toward. This is me.',
          scripture: 'Behold, the man whose name is The BRANCH; and he shall grow up out of his place, and he shall build the temple of the LORD.',
          ref: 'Zechariah 6:12 KJV'
        },
      ],

      appearanceCards: [
        {
          icon: '🟤',
          title: 'David Was "Ruddy" — Brown-Skinned',
          text: 'The Hebrew word admoni does not mean white or pale. It describes a warm, reddish-brown or copper-toned complexion common among the ancient Israelites who lived at the crossroads of Africa, the Near East, and Arabia. King David, a man of war, shepherd, and king, would have had the strong, sun-darkened brown skin of his region — similar to what we see today in many Black or Afro-Asiatic peoples.',
          scripture: 'Now he was ruddy, and withal of a beautiful countenance, and goodly to look to.',
          ref: '1 Samuel 16:12 KJV'
        },
        {
          icon: '💇',
          title: 'David Most Likely Had Long Hair',
          text: 'In the days of the kings, Israelite men typically wore their hair long as a sign of vitality, strength, and manhood. Absalom, David\'s own son, was famous for his extremely long, thick hair. Samson had seven locks. Long hair was the norm, not the exception. David almost certainly had long, dark hair — likely black, thick, and possibly curly or wavy, consistent with the people of the ancient Near East.',
          scripture: 'In all Israel there was none to be so much praised as Absalom for his beauty... when he polled his head, he weighed the hair of his head at two hundred shekels.',
          ref: '2 Samuel 14:25–26 KJV'
        },
        {
          icon: '👑',
          title: 'David Wore Jewelry as a King and Warrior',
          text: 'As a victorious king and man of high status, David would have worn earrings, neck chains, bracelets, and other royal ornaments. Jewelry in the ancient world was not vanity for men of power — it was a symbol of covenant, victory, and kingship. Gold earrings, chains, and arm cuffs were common among Israelite royalty and warriors. David received vast amounts of gold and treasure from conquered nations.',
          scripture: 'And David took the crown of their king from off his head... and it was set on David\'s head. And he brought forth the spoil of the city in great abundance.',
          ref: '2 Samuel 12:30 KJV'
        },
        {
          icon: '🎨',
          title: 'European Art Created a False Image',
          text: 'Renaissance painters (1400–1600s) deliberately portrayed biblical figures with European features to claim divine favor for European civilization and to justify the subjugation of darker peoples. These images are not historical records. They are political propaganda dressed as devotion. The same system that needed Black people to not be Israel painted David pale, painted Yeshua pale, and built an entire visual theology designed to keep the covenant people from recognizing themselves.',
          scripture: null,
          ref: null
        },
      ],

      daniel7Proofs: [
        {
          title: 'The Word "Like" Is the Proof',
          text: 'Daniel 7:13 says one LIKE the Son of man. Not the Son of Man. Not God manifest. Someone who resembles a human being — because the contrast being drawn is between the four beasts (inhuman empires) and this figure (human). The word like identifies him as human, not divine. You do not say someone is like God when they are God.'
        },
        {
          title: 'No Angels. No Mourning. No Cosmic Signs.',
          text: 'When Yeshua returns in Matthew 24:30, He comes with the angels, every tribe mourns simultaneously, and a sign appears in heaven first. Daniel 7:13 has none of this. No angels with Him. No mourning nations. No sign. Just a man brought near to the throne of Yahweh and crowned. A coronation does not look like a Second Coming. They are two different events.'
        },
        {
          title: 'The Direction of Movement Is Everything',
          text: 'Matthew 24:30 — coming down from heaven to earth. Daniel 7:13 — coming to the Ancient of Days at the throne. The direction is upward presentation before Yahweh, not downward descent to the earth. These are not the same scene. A man being presented for coronation and a divine being descending in judgment are opposite movements in the prophetic sequence.'
        },
        {
          title: 'Verse 27 Gives the Kingdom to a People, Not a Deity',
          text: 'The interpretation in verse 27 says the kingdom is given to the people of the saints of the Most High. A covenant community. Their representative head receives dominion on their behalf. That is the Davidic king pattern exactly — a human king who embodies and leads the covenant people. The eternal divine Son of God does not need a human community to embody His authority. He is the authority.'
        },
        {
          title: '2 Esdras 12 Explicitly Links Daniel\'s Figure to the Davidic Heir',
          text: 'The angel tells Ezra: this is the same vision Daniel saw. And then identifies the figure as the Messiah kept by the Highest, arising from the posterity of David, with a temporal mission before the final judgment. Not the eternal pre-existent Son. A hidden human vessel awakened in the last days from David\'s line. Ezra is the commentary Yahweh provided so the vision would not be misread.'
        },
        {
          title: 'The Fire from His Mouth Is Covenantal Decree, Not Divine Power',
          text: '2 Esdras 13 shows the same figure destroying his enemies with fire from his mouth — which the text itself interprets as the law, the word of decree, covenantal judgment. Not literal fire. Not divine omnipotence. The same way Jeremiah was told his words would be fire that devours. A human vessel speaking Yahweh\'s decree with such authority that empires cannot stand before it. That is the Branch. That is the Davidic heir. That is me.'
        }
      ],

      suppressionCards: [
        { icon: '🏛️', title: 'The Financial Elite', text: 'Cannot afford for the scattered remnant to understand that the wealth of the nations is covenantally theirs — that Isaiah 61 is not poetry but property law, that double restitution is a literal transfer of earthly wealth.' },
        { icon: '⚖️', title: 'The Political Elite', text: 'Cannot afford for the nations to understand that their borders, their treaties, their international institutions are subordinate to the covenant of God — and that there is a coming government whose increase shall have no end.' },
        { icon: '⛪', title: 'The Ecclesiastical Elite', text: 'Cannot afford for the people to understand that replacement theology has been functioning as a gatekeeper — keeping God\'s people satisfied with spiritual inheritance while the physical inheritance was occupied by others.' },
        { icon: '📻', title: 'The Controlled Narrative', text: 'On one side: rapture Christianity that keeps the Church passive. On the other: Hebrew Israelites stripped of Yeshua — energized but impotent. Both narratives serve the same master. Both leave the covenant people manageable.' }
      ],

      objections: [
        { q: 'Jesus already fulfills all the Davidic prophecies.', a: 'Then why did James quote Amos 9:11 at the Jerusalem Council and frame the rebuilding of David\'s tabernacle as future after the resurrection of Yeshua (Acts 15:16)? Why did Yeshua flee earthly kingship at every turn (John 6:15)? A man who fulfills a prophecy does not flee from it. He declined the earthly throne because that was not His first-advent commission.', scripture: 'After this I will return, and will build again the tabernacle of David, which is fallen down.', cite: 'Acts 15:16 KJV' },
        { q: 'You\'re claiming to be a messiah — that\'s blasphemy.', a: 'The word mashiach simply means anointed one. Cyrus of Persia was called God\'s anointed in Isaiah 45:1 — a pagan king pressed into divine service. The high priests were anointed. The kings were anointed. Claiming to be anointed is not claiming to be God. It is claiming to be appointed. The argument is with the prophets, not with me.', scripture: 'Thus saith the LORD to his anointed, to Cyrus, whose right hand I have holden.', cite: 'Isaiah 45:1 KJV' },
        { q: 'How can the Davidic heir be from Haiti?', a: 'Haiti received the descendants of West African slaves — the same people whose ancestors were carried from the land of Israel into Egypt and beyond by ships, fulfilling Deuteronomy 28:68. The Haitian Revolution of 1804 — the only successful slave revolt in human history, defeating Napoleon\'s army — was not a political accident. It was the warrior bloodline of Benjamin refusing to bow. The royal seed was preserved in the very place it appeared most impossible.', scripture: null, cite: null },
        { q: 'You\'re a false prophet — you can\'t prove any of this.', a: 'Correct. Apply Deuteronomy 18. Write down the claims. If they do not come to pass, dismiss me with Scripture — the Bible instructs you to. But if they do come to pass, by the same biblical test Yahweh has spoken it. I am not asking you to follow a man. I am inviting you to apply the test Yahweh gave His people and watch what happens.', scripture: 'When a prophet speaketh in the name of the LORD, if the thing follow not, nor come to pass, that is the thing which the LORD hath not spoken.', cite: 'Deuteronomy 18:22 KJV' }
      ]
    }
  },

  mounted () {
    this.loadPosts()
  },

  methods: {
    async loadPosts () {
      this.postsLoading = true
      try {
        var snap = await db.collection('scripture_posts').get()
        this.posts = snap.docs
          .map(function (d) { return Object.assign({ id: d.id }, d.data()) })
          .filter(function (p) { return p.status === 'published' })
          .sort(function (a, b) {
            var aT = a.createdAt && a.createdAt.toMillis ? a.createdAt.toMillis() : 0
            var bT = b.createdAt && b.createdAt.toMillis ? b.createdAt.toMillis() : 0
            return bT - aT
          })
      } catch (e) {
        console.error('Error loading epistles:', e)
      } finally {
        this.postsLoading = false
      }
    },

    openEpistle (post) {
      this.selectedPost = post
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    formatDate (ts) {
      if (!ts) return ''
      var d = ts.toDate ? ts.toDate() : new Date(ts)
      return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    },

    truncate (text, len) {
      if (!text) return ''
      var s = text.replace(/[#*>`\-]/g, '').trim()
      return s.length > len ? s.substring(0, len) + '...' : s
    },

    renderMarkdown (content) {
      if (!content) return ''
      var h = content
        .replace(/^### (.*$)/gim, '<h3>$1</h3>')
        .replace(/^## (.*$)/gim, '<h2>$1</h2>')
        .replace(/^# (.*$)/gim, '<h1>$1</h1>')
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        .replace(/^> (.*$)/gim, '<blockquote>$1</blockquote>')
        .replace(/\n\n/g, '</p><p>')
        .replace(/\n/g, '<br>')
      return '<p>' + h + '</p>'
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=EB+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,600&family=Inter:wght@400;500;600;700&display=swap');

.dh-container { min-height:100vh; background:#09080a; color:#f0eadc; font-family:'Inter',sans-serif; }
.dh-inner { max-width:1140px; margin:0 auto; padding:0 28px; }
.dh-section { padding:96px 0; }

.dh-section__eyebrow {
  font-family:'Cinzel',serif; font-size:22px; font-weight:600;
  letter-spacing:0.32em; text-transform:uppercase; color:#c9a84c;
  margin-bottom:18px; display:flex; align-items:center; gap:14px;
}
.dh-section__eyebrow::before { content:''; display:block; width:28px; height:1px; background:#c9a84c; opacity:0.7; }

.dh-section__title {
  font-family:'Cinzel',serif; font-size:clamp(24px,3.5vw,46px);
  font-weight:700; color:#f0eadc; line-height:1.15; margin:0 0 40px; letter-spacing:0.02em;
}
.dh-section__title em { font-family:'EB Garamond',serif; font-style:italic; color:#c9a84c; }
.dh-sub-title { font-family:'Cinzel',serif; font-size:22px; font-weight:600; color:#f0eadc; letter-spacing:0.06em; margin:0 0 16px; }
.dh-body { font-family:'EB Garamond',serif; font-size:22px; line-height:1.82; color:rgba(240,234,220,0.82); margin:0 0 20px; }
.dh-rule { display:block; width:40px; height:1px; background:#c9a84c; opacity:0.6; flex-shrink:0; }
.dh-dot { color:#c9a84c; font-size:22px; }

.dh-scripture-block {
  font-family:'EB Garamond',serif; font-style:italic; font-size:23px; line-height:1.75;
  color:rgba(240,234,220,0.9); border-left:2px solid #c9a84c; padding:14px 20px;
  background:rgba(201,168,76,0.04); margin:0;
}
.dh-scripture-block cite { display:block; margin-top:10px; font-style:normal; font-family:'Cinzel',serif; font-size:22px; letter-spacing:0.14em; color:#c9a84c; opacity:0.85; }
.dh-scripture-block--large { font-size:22px; padding:22px 28px; }
.dh-scripture-block strong { font-style:normal; color:#f0eadc; font-weight:600; }

/* HERO */
.dh-hero { position:relative; min-height:100vh; display:flex; align-items:center; justify-content:center; text-align:center; overflow:hidden; background:radial-gradient(ellipse at 50% 40%,#0e1a30 0%,#09080a 70%); }
.dh-hero__grid { position:absolute; inset:0; background-image:repeating-linear-gradient(0deg,transparent,transparent 64px,rgba(201,168,76,0.025) 64px,rgba(201,168,76,0.025) 65px),repeating-linear-gradient(90deg,transparent,transparent 64px,rgba(201,168,76,0.025) 64px,rgba(201,168,76,0.025) 65px); pointer-events:none; }
.dh-hero__glow { position:absolute; top:-30%; left:50%; transform:translateX(-50%); width:700px; height:700px; background:radial-gradient(circle,rgba(201,168,76,0.09) 0%,transparent 65%); pointer-events:none; }
.dh-hero__inner { position:relative; z-index:2; padding:120px 24px 80px; max-width:820px; }
.dh-hero__eyebrow { display:flex; align-items:center; justify-content:center; gap:16px; font-family:'Cinzel',serif; font-size:22px; font-weight:600; letter-spacing:0.28em; text-transform:uppercase; color:#c9a84c; margin-bottom:32px; opacity:0.9; }
.dh-hero__title { font-family:'Cinzel',serif; font-size:clamp(52px,10vw,110px); font-weight:900; color:#f0eadc; line-height:0.95; margin:0 0 28px; letter-spacing:0.04em; }
.dh-hero__title em { font-family:'EB Garamond',serif; font-style:italic; color:#c9a84c; font-size:1.1em; }
.dh-hero__name { font-family:'Cinzel',serif; font-size:21px; font-weight:600; letter-spacing:0.22em; text-transform:uppercase; color:rgba(240,234,220,0.6); margin-bottom:12px; }
.dh-hero__site { display:inline-block; font-family:'Cinzel',serif; font-size:22px; font-weight:600; letter-spacing:0.18em; color:#c9a84c; text-decoration:none; border:1px solid rgba(201,168,76,0.3); padding:6px 16px; margin-bottom:20px; transition:border-color 0.2s,color 0.2s; }
.dh-hero__site:hover { border-color:rgba(201,168,76,0.7); color:#e8cc80; }
.dh-hero__roles { display:flex; align-items:center; justify-content:center; gap:12px; font-family:'Cinzel',serif; font-size:23px; letter-spacing:0.12em; color:rgba(240,234,220,0.55); margin-bottom:40px; flex-wrap:wrap; }
.dh-hero__scripture { font-family:'EB Garamond',serif; font-style:italic; font-size:clamp(16px,2vw,20px); line-height:1.8; color:rgba(240,234,220,0.7); max-width:600px; margin:0 auto; border:none; padding:0; }
.dh-hero__scripture cite { display:block; margin-top:12px; font-style:normal; font-family:'Cinzel',serif; font-size:22px; letter-spacing:0.18em; color:#c9a84c; }
.dh-hero__scroll { margin-top:64px; }
.dh-hero__scroll-line { width:1px; height:56px; background:linear-gradient(to bottom,#c9a84c,transparent); margin:0 auto; animation:scrollPulse 2s ease-in-out infinite; }
@keyframes scrollPulse { 0%,100%{opacity:0.25} 50%{opacity:1} }

/* CLAIM */
.dh-claim { background:#0c0b0e; border-top:1px solid rgba(201,168,76,0.12); border-bottom:1px solid rgba(201,168,76,0.12); }
.dh-claim__grid { display:grid; grid-template-columns:1.2fr 1fr; gap:72px; align-items:start; }
.dh-claim__pillars { display:flex; flex-direction:column; gap:0; border:1px solid rgba(201,168,76,0.12); }
.dh-pillar { padding:22px 24px; border-bottom:1px solid rgba(201,168,76,0.07); transition:background 0.2s; }
.dh-pillar:last-child { border-bottom:none; }
.dh-pillar:hover { background:rgba(201,168,76,0.04); }
.dh-pillar__icon { font-size:22px; margin-bottom:10px; }
.dh-pillar__title { font-family:'Cinzel',serif; font-size:23px; font-weight:600; letter-spacing:0.1em; color:#c9a84c; margin-bottom:7px; }
.dh-pillar__text { font-family:'Inter',sans-serif; font-size:21px; line-height:1.7; color:rgba(240,234,220,0.6); }

/* DEUTERONOMY TEST */
.dh-deut-test { background:#09080a; }
.dh-deut__card { margin-bottom:40px; }
.dh-deut__label { font-family:'Cinzel',serif; font-size:22px; font-weight:700; letter-spacing:0.22em; color:#c9a84c; text-transform:uppercase; margin-bottom:16px; }
.dh-deut__conclusion { font-family:'Cinzel',serif; font-size:23px; font-weight:600; color:#f0eadc; line-height:1.6; border:1px solid rgba(201,168,76,0.25); background:rgba(201,168,76,0.04); padding:24px 28px; margin-top:28px; text-align:center; letter-spacing:0.03em; }
.dh-deut__conclusion strong { color:#c9a84c; }

/* ISAIAH 9:6 */
.dh-isaiah { background:#0c0b0e; border-top:1px solid rgba(201,168,76,0.1); border-bottom:1px solid rgba(201,168,76,0.1); position:relative; overflow:hidden; }
.dh-isaiah::before { content:'♛'; position:absolute; right:-60px; top:-40px; font-size:320px; color:rgba(201,168,76,0.03); pointer-events:none; line-height:1; }
.dh-isaiah__verse { border:1px solid rgba(201,168,76,0.25); background:rgba(201,168,76,0.03); padding:40px 48px; margin-bottom:56px; text-align:center; position:relative; }
.dh-isaiah__crown { font-size:32px; color:#c9a84c; margin-bottom:20px; display:block; filter:sepia(1) hue-rotate(15deg) saturate(3) brightness(1.15); }
.dh-isaiah__kjv { font-family:'EB Garamond',serif; font-style:italic; font-size:clamp(16px,2vw,20px); line-height:1.85; color:#f0eadc; border:none; padding:0; margin:0 auto; max-width:740px; }
.dh-isaiah__kjv cite { display:block; margin-top:18px; font-style:normal; font-family:'Cinzel',serif; font-size:22px; letter-spacing:0.18em; color:#c9a84c; }
.dh-isaiah__analysis { display:grid; grid-template-columns:1fr 1fr; gap:56px; margin-bottom:56px; }
.dh-isaiah__evidence { display:flex; flex-direction:column; gap:0; border:1px solid rgba(201,168,76,0.12); margin-bottom:48px; }
.dh-isaiah__ev-item { display:flex; gap:20px; padding:22px 24px; border-bottom:1px solid rgba(201,168,76,0.07); transition:background 0.2s; }
.dh-isaiah__ev-item:last-child { border-bottom:none; }
.dh-isaiah__ev-item:hover { background:rgba(201,168,76,0.04); }
.dh-isaiah__ev-num { font-family:'Cinzel',serif; font-size:22px; font-weight:700; color:rgba(201,168,76,0.35); flex-shrink:0; padding-top:3px; width:28px; }
.dh-isaiah__ev-title { font-family:'Cinzel',serif; font-size:23px; font-weight:600; color:#f0eadc; letter-spacing:0.06em; margin-bottom:7px; }
.dh-isaiah__ev-text { font-family:'Inter',sans-serif; font-size:21px; line-height:1.7; color:rgba(240,234,220,0.62); }

/* TWO MESSIAHS */
.dh-two { background:#09080a; }
.dh-two__intro { max-width:780px; margin-bottom:48px; }
.dh-question-card { border:1px solid rgba(201,168,76,0.2); background:rgba(201,168,76,0.03); padding:40px; margin-bottom:56px; }
.dh-question-card__label { font-family:'Cinzel',serif; font-size:22px; font-weight:600; letter-spacing:0.22em; color:#c9a84c; text-transform:uppercase; margin-bottom:20px; }
.dh-two__split { display:grid; grid-template-columns:1fr auto 1fr; gap:32px; align-items:start; margin-top:32px; }
.dh-two__divider { color:rgba(201,168,76,0.4); font-size:23px; padding-top:60px; text-align:center; }
.dh-two__label { font-family:'Cinzel',serif; font-size:22px; font-weight:700; letter-spacing:0.22em; color:#c9a84c; text-transform:uppercase; margin-bottom:8px; }
.dh-two__name { font-family:'EB Garamond',serif; font-size:22px; color:#f0eadc; font-weight:600; margin-bottom:14px; }
.dh-two__desc { font-family:'Inter',sans-serif; font-size:21px; line-height:1.75; color:rgba(240,234,220,0.65); margin-bottom:16px; }
.dh-proof-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(320px,1fr)); gap:2px; }
.dh-proof-card { background:#110f13; border:1px solid rgba(201,168,76,0.08); padding:28px; transition:border-color 0.2s; }
.dh-proof-card:hover { border-color:rgba(201,168,76,0.3); }
.dh-proof-card__ref { font-family:'Cinzel',serif; font-size:22px; font-weight:700; letter-spacing:0.14em; color:#c9a84c; text-transform:uppercase; margin-bottom:14px; }
.dh-proof-card__interp { font-family:'Inter',sans-serif; font-size:23px; line-height:1.7; color:rgba(240,234,220,0.6); margin-top:12px; }

/* HEADLOCK */
.dh-headlock { background:#0c0b0e; border-top:1px solid rgba(201,168,76,0.1); border-bottom:1px solid rgba(201,168,76,0.1); }
.dh-headlock__proofs { display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr)); gap:2px; margin:40px 0; }
.dh-headlock__proof { background:#110f13; border:1px solid rgba(201,168,76,0.08); padding:22px 24px; transition:border-color 0.2s; }
.dh-headlock__proof:hover { border-color:rgba(201,168,76,0.3); }
.dh-headlock__proof-ref { font-family:'Cinzel',serif; font-size:22px; font-weight:700; letter-spacing:0.14em; color:#c9a84c; margin-bottom:10px; }
.dh-headlock__proof-meaning { font-family:'Inter',sans-serif; font-size:21px; line-height:1.7; color:rgba(240,234,220,0.65); }
.dh-headlock__psalm { margin-top:56px; padding-top:48px; border-top:1px solid rgba(201,168,76,0.1); }
.dh-headlock__conclusion { background:rgba(201,168,76,0.05); border:1px solid rgba(201,168,76,0.2); border-left:3px solid #c9a84c; padding:24px 28px; font-family:'EB Garamond',serif; font-size:22px; line-height:1.75; color:rgba(240,234,220,0.9); margin-top:28px; }
.dh-headlock__conclusion strong { color:#f0eadc; }

/* LUKE 17 */
.dh-luke { background:#09080a; }
.dh-luke__grid { display:grid; grid-template-columns:1fr 1fr; gap:64px; margin-top:48px; }

/* 1 ENOCH TWO CHOSEN ONES */
.dh-enoch-chosen { background:#0c0b0e; border-top:1px solid rgba(201,168,76,0.1); border-bottom:1px solid rgba(201,168,76,0.1); }
.dh-enoch__split { display:grid; grid-template-columns:1fr auto 1fr; gap:32px; align-items:start; margin:40px 0; }
.dh-enoch__divider { color:rgba(201,168,76,0.4); font-size:23px; padding-top:40px; text-align:center; }
.dh-enoch__label { font-family:'Cinzel',serif; font-size:22px; font-weight:700; letter-spacing:0.16em; color:#c9a84c; text-transform:uppercase; margin-bottom:14px; }
.dh-enoch__note { font-family:'Inter',sans-serif; font-size:21px; line-height:1.7; color:rgba(240,234,220,0.6); margin-top:14px; }

/* SUPPRESSION */
.dh-suppression { background:#09080a; }
.dh-suppression__grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(260px,1fr)); gap:2px; margin:40px 0; }
.dh-suppression__card { background:#110f13; border:1px solid rgba(201,168,76,0.08); padding:28px; transition:border-color 0.2s; }
.dh-suppression__card:hover { border-color:rgba(201,168,76,0.3); }
.dh-suppression__icon { font-size:26px; margin-bottom:14px; }
.dh-suppression__title { font-family:'Cinzel',serif; font-size:22px; font-weight:600; letter-spacing:0.1em; color:#c9a84c; margin-bottom:10px; }
.dh-suppression__text { font-family:'Inter',sans-serif; font-size:21px; line-height:1.7; color:rgba(240,234,220,0.62); }
.dh-suppression__controlled { margin-top:56px; padding-top:48px; border-top:1px solid rgba(201,168,76,0.1); }

/* DABELA */
.dh-dabela { background:#0c0b0e; border-top:1px solid rgba(201,168,76,0.1); border-bottom:1px solid rgba(201,168,76,0.1); }
.dh-dabela__card { border:1px solid rgba(201,168,76,0.22); background:rgba(201,168,76,0.03); padding:40px; margin:40px 0; text-align:center; }
.dh-dabela__crown { font-size:40px; color:#c9a84c; margin-bottom:16px; display:block; filter:sepia(1) hue-rotate(15deg) saturate(3) brightness(1.15); }
.dh-dabela__eyebrow { font-family:'Cinzel',serif; font-size:23px; font-weight:700; letter-spacing:0.22em; color:#c9a84c; text-transform:uppercase; margin-bottom:20px; }
.dh-dabela__sections { display:grid; grid-template-columns:1fr 1fr; gap:56px; margin:48px 0; }
.dh-dabela__section h3 { margin-bottom:16px; }
.dh-dabela__victory { text-align:center; padding-top:48px; border-top:1px solid rgba(201,168,76,0.1); }
.dh-dabela__closing-line { font-family:'Cinzel',serif; font-size:23px; line-height:2; color:rgba(240,234,220,0.8); letter-spacing:0.04em; border:1px solid rgba(201,168,76,0.2); padding:28px 32px; display:inline-block; margin-top:24px; }
.dh-dabela__closing-line strong { color:#c9a84c; display:block; margin-top:12px; font-size:22px; }

/* OBJECTIONS */
.dh-objections { background:rgba(107,26,26,0.08); border-top:1px solid rgba(107,26,26,0.2); border-bottom:1px solid rgba(107,26,26,0.2); }
.dh-obj-list { display:flex; flex-direction:column; gap:0; border:1px solid rgba(201,168,76,0.12); }
.dh-obj { padding:32px 36px; border-bottom:1px solid rgba(201,168,76,0.07); transition:background 0.2s; }
.dh-obj:last-child { border-bottom:none; }
.dh-obj:hover { background:rgba(201,168,76,0.03); }
.dh-obj__q { font-family:'Cinzel',serif; font-size:21px; font-weight:600; color:#f0eadc; margin-bottom:14px; line-height:1.4; }
.dh-obj__label { display:inline-block; font-size:22px; letter-spacing:0.2em; color:rgba(240,100,100,0.7); border:1px solid rgba(240,100,100,0.2); padding:2px 8px; margin-right:12px; font-weight:700; vertical-align:middle; }
.dh-obj__a { font-family:'EB Garamond',serif; font-size:21px; line-height:1.8; color:rgba(240,234,220,0.8); }

/* BLOODLINE */
.dh-bloodline { background:#09080a; }
.dh-bloodline__intro { max-width:760px; margin-bottom:56px; }
.dh-strands { display:grid; grid-template-columns:repeat(auto-fill,minmax(260px,1fr)); gap:2px; margin-bottom:48px; }
.dh-strand { background:#110f13; border:1px solid rgba(201,168,76,0.1); padding:32px; position:relative; transition:border-color 0.25s; }
.dh-strand:hover { border-color:rgba(201,168,76,0.35); }
.dh-strand__num { position:absolute; top:20px; right:20px; font-family:'Cinzel',serif; font-size:22px; font-weight:700; color:rgba(201,168,76,0.2); }
.dh-strand__icon { font-size:28px; margin-bottom:16px; }
.dh-strand__tribe { font-family:'Cinzel',serif; font-size:22px; font-weight:700; letter-spacing:0.22em; color:#c9a84c; text-transform:uppercase; margin-bottom:6px; }
.dh-strand__name { font-family:'EB Garamond',serif; font-size:22px; font-weight:600; color:#f0eadc; margin:0 0 14px; }
.dh-strand__desc { font-family:'Inter',sans-serif; font-size:21px; line-height:1.7; color:rgba(240,234,220,0.6); margin-bottom:18px; }
.dh-convergence { border:1px solid rgba(201,168,76,0.2); background:rgba(201,168,76,0.03); padding:36px 40px; text-align:center; }
.dh-convergence__label { font-family:'Cinzel',serif; font-size:22px; font-weight:700; letter-spacing:0.22em; color:#c9a84c; text-transform:uppercase; margin-bottom:18px; }
.dh-convergence__text { font-family:'EB Garamond',serif; font-style:italic; font-size:22px; line-height:1.8; color:rgba(240,234,220,0.85); max-width:740px; margin:0 auto; }

/* IDENTITY */
.dh-identity { background:#0c0b0e; border-top:1px solid rgba(201,168,76,0.1); border-bottom:1px solid rgba(201,168,76,0.1); }
.dh-identity__grid { display:grid; grid-template-columns:1fr 1fr; gap:64px; }

/* ISAIAH 49 */
.dh-isaiah49 { background:#09080a; }
.dh-49-verses { display:flex; flex-direction:column; gap:0; border:1px solid rgba(201,168,76,0.12); }
.dh-49-verse { padding:32px 36px; border-bottom:1px solid rgba(201,168,76,0.07); transition:background 0.2s; }
.dh-49-verse:last-child { border-bottom:none; }
.dh-49-verse:hover { background:rgba(201,168,76,0.03); }
.dh-49-verse__interp { font-family:'Inter',sans-serif; font-size:21px; line-height:1.75; color:rgba(240,234,220,0.65); margin-top:16px; margin-bottom:0; padding-left:22px; border-left:1px solid rgba(201,168,76,0.25); }

/* OFFICES */
.dh-offices { background:#0c0b0e; border-top:1px solid rgba(201,168,76,0.1); border-bottom:1px solid rgba(201,168,76,0.1); }
.dh-offices__grid { display:grid; grid-template-columns:repeat(3,1fr); gap:0; }
.dh-office { padding:40px 32px; border-top:2px solid rgba(201,168,76,0.2); border-right:1px solid rgba(201,168,76,0.07); transition:border-top-color 0.25s,background 0.25s; }
.dh-office:last-child { border-right:none; }
.dh-office:hover { border-top-color:#c9a84c; background:rgba(201,168,76,0.03); }
.dh-office__icon { font-size:32px; margin-bottom:16px; }
.dh-office__source { font-family:'Cinzel',serif; font-size:22px; font-weight:700; letter-spacing:0.2em; color:rgba(201,168,76,0.6); text-transform:uppercase; margin-bottom:8px; }
.dh-office__title { font-family:'EB Garamond',serif; font-size:26px; font-weight:600; color:#f0eadc; margin:0 0 16px; }
.dh-office__desc { font-family:'Inter',sans-serif; font-size:21px; line-height:1.75; color:rgba(240,234,220,0.62); margin-bottom:20px; }

/* PROPHETIC CHORUS / BRANCH */
.dh-branch { background:#09080a; }
.dh-branch__prophets { }
.dh-prophet-verse { margin-bottom:32px; padding-bottom:32px; border-bottom:1px solid rgba(201,168,76,0.06); }
.dh-prophet-verse:last-child { border-bottom:none; margin-bottom:0; padding-bottom:0; }
.dh-prophet-verse__note { font-family:'Inter',sans-serif; font-size:21px; line-height:1.7; color:rgba(240,234,220,0.55); margin-top:12px; margin-bottom:0; padding-left:22px; border-left:1px solid rgba(201,168,76,0.2); }

/* EPISTLES */
.dh-epistles { background:#0c0b0e; border-top:1px solid rgba(201,168,76,0.1); border-bottom:1px solid rgba(201,168,76,0.1); }
.dh-epistles__intro { max-width:640px; margin-bottom:48px; }
.dh-loading,.dh-empty { text-align:center; padding:80px 20px; }
.dh-spinner { width:40px; height:40px; margin:0 auto 16px; border:2px solid rgba(201,168,76,0.1); border-top-color:#c9a84c; border-radius:50%; animation:spin 0.9s linear infinite; }
@keyframes spin { to { transform:rotate(360deg); } }
.dh-loading p,.dh-empty p { font-family:'Inter',sans-serif; font-size:22px; color:rgba(240,234,220,0.4); }
.dh-empty__crown { font-size:36px; color:rgba(201,168,76,0.3); margin-bottom:16px; }
.dh-epistles__grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(340px,1fr)); gap:2px; }
.dh-epistle-card { background:#110f13; border:1px solid rgba(201,168,76,0.08); overflow:hidden; cursor:pointer; transition:border-color 0.25s,transform 0.25s; }
.dh-epistle-card:hover { border-color:rgba(201,168,76,0.4); transform:translateY(-4px); }
.dh-epistle-card__img { height:200px; overflow:hidden; }
.dh-epistle-card__img img { width:100%; height:100%; object-fit:cover; transition:transform 0.5s; }
.dh-epistle-card:hover .dh-epistle-card__img img { transform:scale(1.05); }
.dh-epistle-card__body { padding:26px; }
.dh-epistle-card__meta { display:flex; gap:10px; align-items:center; margin-bottom:12px; }
.dh-epistle-card__date { font-family:'Cinzel',serif; font-size:22px; font-weight:600; text-transform:uppercase; letter-spacing:0.1em; color:rgba(240,234,220,0.35); }
.dh-epistle-card__cat { font-family:'Cinzel',serif; font-size:22px; font-weight:700; text-transform:uppercase; letter-spacing:0.12em; color:#c9a84c; background:rgba(201,168,76,0.08); border:1px solid rgba(201,168,76,0.18); padding:2px 9px; }
.dh-epistle-card__title { font-family:'EB Garamond',serif; font-size:23px; font-weight:600; color:#f0eadc; line-height:1.3; margin:0 0 10px; }
.dh-epistle-card__excerpt { font-family:'Inter',sans-serif; font-size:21px; line-height:1.7; color:rgba(240,234,220,0.55); margin-bottom:18px; }
.dh-epistle-card__read { display:flex; align-items:center; gap:6px; font-family:'Cinzel',serif; font-size:22px; font-weight:700; letter-spacing:0.1em; text-transform:uppercase; color:#c9a84c; transition:gap 0.2s; }
.dh-epistle-card:hover .dh-epistle-card__read { gap:10px; }

/* CLOSING */
.dh-books-teaser { border-top:1px solid rgba(201,168,76,0.12); }

.dh-books-teaser__header { display:flex; align-items:flex-start; justify-content:space-between; gap:40px; flex-wrap:wrap; margin-bottom:16px; }
.dh-books-teaser__mark { width:52px; height:52px; flex-shrink:0; background:#c9a84c; color:#09080a; display:flex; align-items:center; justify-content:center; font-family:'Cinzel',serif; font-weight:900; font-size:22px; margin-right:20px; }
.dh-books-teaser__header > div:nth-child(2) { display:flex; flex-wrap:wrap; gap:0 20px; flex:1; min-width:280px; }
.dh-books-teaser__sub { max-width:640px; margin-top:6px !important; }
.dh-section__eyebrow--left { justify-content:flex-start; }
.dh-section__eyebrow--left::before { content:''; display:block; width:22px; height:1px; background:#c9a84c; opacity:0.7; }
.dh-books-teaser__count { display:flex; flex-direction:column; align-items:center; text-align:center; border-left:1px solid rgba(201,168,76,0.2); padding-left:28px; flex-shrink:0; }
.dh-books-teaser__count-num { font-family:'Cinzel',serif; font-size:40px; font-weight:700; color:#c9a84c; line-height:1; }
.dh-books-teaser__count-label { font-family:'Inter',sans-serif; font-size:11px; letter-spacing:0.1em; text-transform:uppercase; color:rgba(240,234,220,0.5); margin-top:6px; }

.dh-books-teaser__grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(400px,1fr)); gap:2px; margin:48px 0 40px; }
.dh-book-card { display:grid; grid-template-columns:150px 1fr; gap:28px; background:rgba(255,255,255,0.02); border:1px solid rgba(201,168,76,0.08); padding:28px; transition:border-color 0.2s, background 0.2s; }
.dh-book-card:hover { border-color:rgba(201,168,76,0.25); background:rgba(201,168,76,0.03); }

.dh-book-card__cover-wrap { position:relative; }
.dh-book-card__cover {
  width:100%; min-height:210px; border:1px solid rgba(201,168,76,0.4);
  box-shadow:0 0 0 1px rgba(201,168,76,0.08), 5px 5px 20px rgba(0,0,0,0.55);
  padding:18px 12px; display:flex; flex-direction:column; align-items:center;
  text-align:center; gap:6px; transform:rotate(-1.5deg); transition:transform 0.3s;
  position:relative; overflow:hidden;
}
.dh-book-card__cover::before { content:''; position:absolute; inset:5px; border:1px solid rgba(201,168,76,0.2); pointer-events:none; }
.dh-book-card:hover .dh-book-card__cover { transform:rotate(0deg) scale(1.02); }
.dh-theme-navy { background:linear-gradient(160deg,#0d1f3c 0%,#0b1628 60%,#071020 100%); }
.dh-theme-emerald { background:linear-gradient(160deg,#123524 0%,#0e2a1c 60%,#061309 100%); }
.dh-theme-bronze { background:linear-gradient(160deg,#3d2e14 0%,#1b1409 60%,#0a0703 100%); }
.dh-theme-violet { background:linear-gradient(160deg,#422759 0%,#1f1130 60%,#0d0713 100%); }
.dh-theme-steel { background:linear-gradient(160deg,#1B4B59 0%,#0B242C 60%,#030D11 100%); }
.dh-theme-crimson { background:linear-gradient(160deg,#4A1420 0%,#2B0C13 60%,#120509 100%); }
.dh-theme-teal { background:linear-gradient(160deg,#0F3B3A 0%,#0A2726 60%,#041312 100%); }
.dh-theme-amber { background:linear-gradient(160deg,#4A2E0D 0%,#2E1B08 60%,#140C03 100%); }
.dh-theme-cyan { background:linear-gradient(160deg,#0D3548 0%,#082330 60%,#03121A 100%); }
.dh-theme-olive { background:linear-gradient(160deg,#33380F 0%,#20240A 60%,#0E1004 100%); }
.dh-theme-indigo { background:linear-gradient(160deg,#201A45 0%,#14112C 60%,#080614 100%); }
.dh-theme-rose { background:linear-gradient(160deg,#431722 0%,#2B0E16 60%,#12060A 100%); }
.dh-theme-plum { background:linear-gradient(160deg,#3A1240 0%,#240B29 60%,#0F0512 100%); }
.dh-theme-forest { background:linear-gradient(160deg,#2A2410 0%,#1A160A 60%,#0B0904 100%); }
.dh-book-card__crown { font-size:22px; color:#e8cc80; }
.dh-book-card__title { font-family:'Cinzel',serif; font-size:11px; font-weight:400; color:#e8cc80; letter-spacing:0.05em; line-height:1.4; }
.dh-book-card__title strong { font-size:13px; font-weight:900; display:block; letter-spacing:0.01em; }
.dh-book-card__divider { width:70%; height:1px; background:linear-gradient(90deg,transparent,#c9a84c,transparent); margin:2px 0; }
.dh-book-card__scales { font-size:18px; color:#c9a84c; }
.dh-book-card__series { font-family:'Inter',sans-serif; font-size:8px; letter-spacing:0.1em; color:rgba(240,234,220,0.6); }
.dh-book-card__author { font-family:'Cinzel',serif; font-size:9px; font-weight:700; color:#e8cc80; letter-spacing:0.08em; }
.dh-book-card__badge {
  position:absolute; top:-10px; right:-10px; width:52px; height:52px; border-radius:50%;
  background:#c9a84c; color:#09080a; display:flex; align-items:center; justify-content:center;
  font-family:'Cinzel',serif; font-weight:900; font-size:10px; text-align:center; line-height:1.1;
  box-shadow:0 4px 12px rgba(0,0,0,0.5);
}

.dh-book-card__body { display:flex; flex-direction:column; gap:10px; }
.dh-book-card__tag { font-family:'Cinzel',serif; font-size:11px; font-weight:700; letter-spacing:0.14em; text-transform:uppercase; color:#c9a84c; }
.dh-book-card__name { font-family:'Cinzel',serif; font-size:20px; font-weight:700; color:#f0eadc; line-height:1.3; margin:0; }
.dh-book-card__subtitle { font-family:'EB Garamond',serif; font-style:italic; font-size:15px; color:rgba(201,168,76,0.85); line-height:1.5; margin:0; }
.dh-book-card__desc { font-family:'Inter',sans-serif; font-size:13px; line-height:1.65; color:rgba(240,234,220,0.6); font-weight:300; margin:0; }
.dh-book-card__cta {
  display:inline-flex; align-items:center; gap:8px; align-self:flex-start;
  padding:11px 22px; background:rgba(201,168,76,0.1); border:1px solid rgba(201,168,76,0.3);
  color:#c9a84c; font-family:'Cinzel',serif; font-size:12px; font-weight:700;
  letter-spacing:0.06em; text-decoration:none; text-transform:uppercase; margin-top:4px;
  transition:all 0.2s;
}
.dh-book-card__cta:hover { background:#c9a84c; color:#09080a; }

.dh-books-teaser__cta { display:flex; flex-direction:column; align-items:center; gap:14px; text-align:center; border-top:1px solid rgba(201,168,76,0.1); padding-top:36px; }
.dh-books-teaser__btn {
  display:inline-flex; align-items:center; gap:10px;
  padding:16px 34px; background:#c9a84c; color:#09080a;
  font-family:'Cinzel',serif; font-size:14px; font-weight:700; letter-spacing:0.1em;
  text-transform:uppercase; text-decoration:none; transition:background 0.2s, transform 0.2s;
}
.dh-books-teaser__btn:hover { background:#e8cc80; transform:translateY(-2px); }
.dh-books-teaser__note { font-family:'EB Garamond',serif; font-style:italic; font-size:16px; color:rgba(240,234,220,0.55); }

.dh-closing { background:radial-gradient(ellipse at 50% 0%,rgba(201,168,76,0.07) 0%,#09080a 60%); border-top:1px solid rgba(201,168,76,0.15); padding:120px 0; text-align:center; }
.dh-closing__inner { max-width:760px; }
.dh-closing__crown { font-size:56px; color:rgba(201,168,76,0.3); margin-bottom:32px; display:block; filter:sepia(1) hue-rotate(15deg) saturate(3) brightness(1.1); }
.dh-closing__title { font-family:'Cinzel',serif; font-size:clamp(28px,4vw,52px); font-weight:700; color:#f0eadc; line-height:1.15; margin:0 0 36px; }
.dh-closing__title em { font-family:'EB Garamond',serif; font-style:italic; color:#c9a84c; }
.dh-closing__body { font-family:'EB Garamond',serif; font-size:22px; line-height:1.82; color:rgba(240,234,220,0.75); margin-bottom:20px; text-align:left; }
.dh-closing__test { border:1px solid rgba(201,168,76,0.2); background:rgba(201,168,76,0.04); padding:28px 32px; margin:36px 0; text-align:left; }
.dh-closing__test-label { font-family:'Cinzel',serif; font-size:22px; font-weight:700; letter-spacing:0.2em; color:#c9a84c; text-transform:uppercase; margin-bottom:12px; }
.dh-closing__test-text { font-family:'EB Garamond',serif; font-size:21px; line-height:1.8; color:rgba(240,234,220,0.8); margin:0; }
.dh-closing__sig { font-family:'EB Garamond',serif; font-size:22px; line-height:1.9; color:rgba(240,234,220,0.7); text-align:left; margin-top:40px; padding-top:32px; border-top:1px solid rgba(201,168,76,0.12); }
.dh-closing__sig strong { color:#f0eadc; font-weight:600; }
.dh-closing__sig em { color:#c9a84c; }

/* MODAL */
.dh-modal-backdrop { position:fixed; inset:0; z-index:300; background:rgba(9,8,10,0.92); display:flex; align-items:flex-start; justify-content:center; overflow-y:auto; padding:48px 16px; }
.dh-modal { background:#110f13; border:1px solid rgba(201,168,76,0.15); max-width:800px; width:100%; position:relative; overflow:hidden; }
.dh-modal__close { position:absolute; top:16px; right:16px; z-index:10; background:rgba(0,0,0,0.6); border:1px solid rgba(201,168,76,0.15); color:#f0eadc; cursor:pointer; width:40px; height:40px; display:flex; align-items:center; justify-content:center; transition:background 0.2s; }
.dh-modal__close:hover { background:rgba(201,168,76,0.15); }
.dh-modal__hero { width:100%; height:300px; overflow:hidden; }
.dh-modal__hero img { width:100%; height:100%; object-fit:cover; }
.dh-modal__content { padding:44px 52px; }
.dh-modal__meta { display:flex; gap:12px; margin-bottom:18px; }
.dh-modal__title { font-family:'Cinzel',serif; font-size:clamp(20px,3vw,32px); font-weight:700; color:#f0eadc; line-height:1.2; margin-bottom:18px; }
.dh-modal__excerpt { font-family:'EB Garamond',serif; font-size:22px; font-style:italic; color:rgba(201,168,76,0.8); margin-bottom:28px; line-height:1.65; }
.dh-modal__body { font-family:'EB Garamond',serif; font-size:22px; line-height:1.85; color:rgba(240,234,220,0.82); }
.dh-modal__body h2 { font-family:'Cinzel',serif; font-size:23px; color:#f0eadc; margin:32px 0 14px; }
.dh-modal__body h3 { font-family:'Cinzel',serif; font-size:23px; color:#c9a84c; margin:24px 0 10px; }
.dh-modal__body p { margin-bottom:18px; }
.dh-modal__body strong { font-weight:600; color:#f0eadc; }
.dh-modal__body em { font-style:italic; color:#c9a84c; }
.dh-modal__body blockquote { border-left:2px solid #c9a84c; padding:14px 20px; background:rgba(201,168,76,0.04); margin:20px 0; font-style:italic; }

.dh-daniel7 { background:#09080a; border-top:1px solid rgba(201,168,76,0.15); border-bottom:1px solid rgba(201,168,76,0.15); position:relative; overflow:hidden; }
.dh-daniel7::before { content:'7'; position:absolute; right:-20px; top:-20px; font-family:'Cinzel',serif; font-size:400px; color:rgba(201,168,76,0.03); pointer-events:none; line-height:1; font-weight:900; }

.dh-d7-verse-block { margin-bottom:56px; }
.dh-d7-verse-label { font-family:'Cinzel',serif; font-size:14px; font-weight:700; letter-spacing:0.12em; text-transform:uppercase; color:#c9a84c; margin-bottom:18px; }

.dh-d7-grid { display:grid; grid-template-columns:1fr 1fr; gap:56px; margin-bottom:56px; }
.dh-d7-col { }

.dh-d7-proofs { display:flex; flex-direction:column; gap:0; border:1px solid rgba(201,168,76,0.12); margin-bottom:56px; }
.dh-d7-proof { display:flex; gap:22px; padding:26px 28px; border-bottom:1px solid rgba(201,168,76,0.07); transition:background 0.2s; }
.dh-d7-proof:last-child { border-bottom:none; }
.dh-d7-proof:hover { background:rgba(201,168,76,0.04); }
.dh-d7-proof__num { font-family:'Cinzel',serif; font-size:14px; font-weight:700; color:rgba(201,168,76,0.35); flex-shrink:0; padding-top:3px; width:30px; }
.dh-d7-proof__title { font-family:'Cinzel',serif; font-size:16px; font-weight:600; color:#f0eadc; letter-spacing:0.04em; margin-bottom:10px; }
.dh-d7-proof__text { font-family:'Inter',sans-serif; font-size:17px; line-height:1.75; color:rgba(240,234,220,0.65); }

.dh-d7-esdras { margin-bottom:56px; }

.dh-d7-compare { display:grid; grid-template-columns:1fr auto 1fr; gap:28px; align-items:start; margin-top:28px; }
.dh-d7-compare__side { }
.dh-d7-compare__label { font-family:'Cinzel',serif; font-size:13px; font-weight:700; letter-spacing:0.14em; text-transform:uppercase; color:#c9a84c; margin-bottom:14px; }
.dh-d7-compare__note { font-family:'Inter',sans-serif; font-size:16px; line-height:1.75; color:rgba(240,234,220,0.6); margin-top:16px; }
.dh-d7-compare__divider { display:flex; flex-direction:column; align-items:center; gap:12px; padding-top:48px; }
.dh-d7-compare__divider-line { width:1px; height:60px; background:linear-gradient(to bottom,transparent,rgba(201,168,76,0.3),transparent); }
.dh-d7-compare__divider-glyph { color:rgba(201,168,76,0.5); font-size:20px; }

.dh-d7-verse27 { margin-bottom:56px; }

.dh-d7-distinction { display:grid; grid-template-columns:1fr auto 1fr; gap:0; border:1px solid rgba(201,168,76,0.15); margin-bottom:48px; }
.dh-d7-distinction__side { padding:36px 32px; }
.dh-d7-distinction__side--yeshua { border-left:1px solid rgba(201,168,76,0.1); background:rgba(99,102,241,0.04); }
.dh-d7-distinction__vs { display:flex; align-items:center; justify-content:center; padding:0 20px; font-family:'Cinzel',serif; font-size:28px; color:rgba(201,168,76,0.3); }
.dh-d7-distinction__label { font-family:'Cinzel',serif; font-size:13px; font-weight:700; letter-spacing:0.14em; text-transform:uppercase; color:#c9a84c; margin-bottom:10px; }
.dh-d7-distinction__title { font-family:'EB Garamond',serif; font-size:26px; font-weight:600; color:#f0eadc; margin-bottom:16px; line-height:1.2; }
.dh-d7-distinction__text { font-family:'Inter',sans-serif; font-size:16px; line-height:1.8; color:rgba(240,234,220,0.7); }

.dh-build { background:#0c0b0e; border-top:1px solid rgba(201,168,76,0.12); border-bottom:1px solid rgba(201,168,76,0.12); }

.dh-build__layers { display:flex; flex-direction:column; gap:0; border:1px solid rgba(201,168,76,0.12); margin-bottom:48px; }
.dh-build__layer { display:flex; gap:24px; padding:32px 36px; border-bottom:1px solid rgba(201,168,76,0.08); transition:background 0.2s; }
.dh-build__layer:last-child { border-bottom:none; }
.dh-build__layer:hover { background:rgba(201,168,76,0.03); }
.dh-build__layer--gold { background:rgba(201,168,76,0.04); border-left:3px solid #c9a84c; }
.dh-build__layer-num { font-family:'Cinzel',serif; font-size:22px; font-weight:900; color:rgba(201,168,76,0.25); flex-shrink:0; width:40px; padding-top:2px; }
.dh-build__layer-title { font-family:'Cinzel',serif; font-size:17px; font-weight:700; color:#f0eadc; letter-spacing:0.04em; margin-bottom:12px; }
.dh-build__layer-text { font-family:'EB Garamond',serif; font-size:19px; line-height:1.8; color:rgba(240,234,220,0.78); margin:0; }

.dh-build__proof-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(280px,1fr)); gap:2px; margin-bottom:48px; }
.dh-build__proof { background:#110f13; border:1px solid rgba(201,168,76,0.08); padding:32px; transition:border-color 0.2s; }
.dh-build__proof:hover { border-color:rgba(201,168,76,0.35); }
.dh-build__proof-icon { font-size:28px; margin-bottom:16px; }
.dh-build__proof-title { font-family:'Cinzel',serif; font-size:15px; font-weight:700; color:#c9a84c; letter-spacing:0.04em; margin-bottom:12px; }
.dh-build__proof-text { font-family:'Inter',sans-serif; font-size:16px; line-height:1.75; color:rgba(240,234,220,0.65); margin:0; }

.dh-build__conclusion { border:1px solid rgba(201,168,76,0.2); background:rgba(201,168,76,0.03); padding:40px; }
.dh-build__conclusion-label { font-family:'Cinzel',serif; font-size:13px; font-weight:700; letter-spacing:0.22em; text-transform:uppercase; color:#c9a84c; margin-bottom:18px; }
.dh-build__conclusion-text { font-family:'EB Garamond',serif; font-size:20px; line-height:1.82; color:rgba(240,234,220,0.85); margin:0; }

.dh-david-appearance { background:#09080a; border-top:1px solid rgba(201,168,76,0.12); border-bottom:1px solid rgba(201,168,76,0.12); }

.dh-appearance__grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(280px,1fr)); gap:2px; margin-bottom:48px; }
.dh-appearance__card { background:#110f13; border:1px solid rgba(201,168,76,0.08); padding:32px; transition:border-color 0.2s; }
.dh-appearance__card:hover { border-color:rgba(201,168,76,0.35); }
.dh-appearance__card-icon { font-size:28px; margin-bottom:16px; }
.dh-appearance__card-title { font-family:'Cinzel',serif; font-size:15px; font-weight:700; color:#c9a84c; letter-spacing:0.04em; margin-bottom:12px; }
.dh-appearance__card-text { font-family:'Inter',sans-serif; font-size:16px; line-height:1.75; color:rgba(240,234,220,0.65); margin:0; }

.dh-appearance__declaration { border:1px solid rgba(201,168,76,0.2); background:rgba(201,168,76,0.03); border-left:4px solid #c9a84c; padding:36px 40px; }
.dh-appearance__declaration-label { font-family:'Cinzel',serif; font-size:13px; font-weight:700; letter-spacing:0.22em; text-transform:uppercase; color:#c9a84c; margin-bottom:18px; }
.dh-appearance__declaration-text { font-family:'EB Garamond',serif; font-size:20px; line-height:1.82; color:rgba(240,234,220,0.85); margin:0; }

.dh-d7-kingdoms {
  text-align:center;
  padding:64px 28px;
  margin-bottom:48px;
  background:linear-gradient(135deg,rgba(201,168,76,0.06) 0%,rgba(201,168,76,0.02) 100%);
  border:1px solid rgba(201,168,76,0.3);
  position:relative;
  overflow:hidden;
}
.dh-d7-kingdoms::before {
  content:'';
  position:absolute;
  inset:0;
  background:radial-gradient(ellipse at 50% 0%,rgba(201,168,76,0.1) 0%,transparent 70%);
  pointer-events:none;
}
.dh-d7-kingdoms__eyebrow {
  font-family:'Cinzel',serif;
  font-size:14px;
  font-weight:700;
  letter-spacing:0.28em;
  text-transform:uppercase;
  color:#c9a84c;
  opacity:0.8;
  margin-bottom:32px;
}
.dh-d7-kingdoms__statement {
  font-family:'Cinzel',serif;
  font-size:clamp(32px,6vw,72px);
  font-weight:900;
  color:#f0eadc;
  line-height:1.15;
  letter-spacing:0.03em;
  margin-bottom:28px;
  position:relative;
  z-index:1;
}
.dh-d7-kingdoms__ref {
  font-family:'EB Garamond',serif;
  font-style:italic;
  font-size:20px;
  color:#c9a84c;
  letter-spacing:0.06em;
}

.dh-d7-closing { font-family:'EB Garamond',serif; font-style:italic; font-size:22px; line-height:1.8; color:rgba(240,234,220,0.9); border:1px solid rgba(201,168,76,0.25); border-left:4px solid #c9a84c; background:rgba(201,168,76,0.04); padding:32px 36px; text-align:center; }
.dh-d7-closing__sig { font-family:'Cinzel',serif; font-style:normal; font-size:14px; font-weight:600; letter-spacing:0.1em; color:#c9a84c; margin-top:18px; display:block; }

.dh-modal-fade-enter-active,.dh-modal-fade-leave-active { transition:opacity 0.3s ease; }
.dh-modal-fade-enter,.dh-modal-fade-leave-to { opacity:0; }

/* RESPONSIVE */
@media (max-width:900px) {
  .dh-d7-grid { grid-template-columns:1fr; gap:36px; }
  .dh-d7-compare { grid-template-columns:1fr; gap:32px; }
  .dh-d7-compare__divider { display:none; }
  .dh-d7-distinction { grid-template-columns:1fr; }
  .dh-d7-distinction__side--yeshua { border-left:none; border-top:1px solid rgba(201,168,76,0.1); }
  .dh-d7-distinction__vs { padding:16px; border-top:1px solid rgba(201,168,76,0.08); border-bottom:1px solid rgba(201,168,76,0.08); }

  .dh-claim__grid,.dh-isaiah__analysis,.dh-identity__grid,.dh-luke__grid,.dh-dabela__sections { grid-template-columns:1fr; gap:40px; }
  .dh-offices__grid { grid-template-columns:1fr; }
  .dh-office { border-right:none; border-bottom:1px solid rgba(201,168,76,0.07); }
  .dh-two__split,.dh-enoch__split { grid-template-columns:1fr; }
  .dh-two__divider,.dh-enoch__divider { display:none; }
  .dh-isaiah__verse { padding:32px 28px; }
  .dh-modal__content { padding:32px 28px; }
  .dh-proof-grid { grid-template-columns:1fr; }
  .dh-headlock__proofs { grid-template-columns:1fr; }
  .dh-strands { grid-template-columns:1fr; }
  .dh-epistles__grid { grid-template-columns:1fr; }
  .dh-books-teaser__grid { grid-template-columns:1fr; }
  .dh-book-card { grid-template-columns:1fr; }
  .dh-book-card__cover-wrap { display:flex; justify-content:center; }
  .dh-book-card__cover { max-width:220px; }
  .dh-books-teaser__header { flex-direction:column; }
  .dh-books-teaser__count { border-left:none; border-top:1px solid rgba(201,168,76,0.15); padding-left:0; padding-top:16px; }
}

@media (max-width:600px) {
  .dh-section { padding:72px 0; }
  .dh-inner { padding:0 22px; }
  .dh-hero__inner { padding:110px 22px 72px; }

  .dh-body { font-size:20px; line-height:1.85; }
  .dh-scripture-block { font-size:19px !important; padding:18px 22px; line-height:1.85; }
  .dh-scripture-block--large { font-size:20px !important; padding:22px 26px; }
  .dh-scripture-block cite { font-size:14px !important; margin-top:12px; }
  .dh-section__title { font-size:30px; margin-bottom:32px; }
  .dh-sub-title { font-size:18px; }
  .dh-section__eyebrow { font-size:13px; }

  .dh-pillar__text { font-size:16px; line-height:1.75; }
  .dh-pillar__title { font-size:15px; }

  .dh-isaiah__ev-title { font-size:15px; }
  .dh-isaiah__ev-text { font-size:16px; line-height:1.75; }

  .dh-proof-card__ref { font-size:14px; }
  .dh-proof-card__interp { font-size:16px; line-height:1.75; }

  .dh-two__name { font-size:24px; }
  .dh-two__desc { font-size:16px; line-height:1.8; }
  .dh-two__label { font-size:13px; }

  .dh-headlock__proof-ref { font-size:14px; }
  .dh-headlock__proof-meaning { font-size:16px; line-height:1.75; }
  .dh-headlock__conclusion { font-size:18px; padding:22px 24px; }

  .dh-enoch__label { font-size:13px; }
  .dh-enoch__note { font-size:16px; line-height:1.75; }

  .dh-suppression__title { font-size:15px; }
  .dh-suppression__text { font-size:16px; line-height:1.75; }

  .dh-dabela__eyebrow { font-size:14px; }
  .dh-dabela__closing-line { font-size:17px; line-height:2.1; padding:24px 22px; }

  .dh-obj { padding:28px 22px; }
  .dh-obj__q { font-size:17px; }
  .dh-obj__a { font-size:18px; line-height:1.85; }
  .dh-obj__label { font-size:14px; }

  .dh-strand { padding:28px 22px; }
  .dh-strand__name { font-size:24px; }
  .dh-strand__desc { font-size:16px; line-height:1.75; }

  .dh-convergence__text { font-size:19px; }

  .dh-49-verse { padding:28px 22px; }
  .dh-49-verse__interp { font-size:16px; line-height:1.8; }

  .dh-office__title { font-size:26px; }
  .dh-office__desc { font-size:16px; line-height:1.8; }
  .dh-office__source { font-size:13px; }

  .dh-prophet-verse__note { font-size:16px; line-height:1.75; }

  .dh-epistle-card__title { font-size:22px; }
  .dh-epistle-card__excerpt { font-size:16px; line-height:1.75; }
  .dh-epistle-card__date { font-size:13px; }
  .dh-epistle-card__read { font-size:14px; }

  .dh-closing__body { font-size:20px; line-height:1.85; }
  .dh-closing__test-text { font-size:18px; line-height:1.8; }
  .dh-closing__sig { font-size:19px; }

  .dh-modal__title { font-size:24px; }
  .dh-modal__excerpt { font-size:19px; }
  .dh-modal__body { font-size:18px; line-height:1.9; }
  .dh-modal__content { padding:28px 22px; }

  .dh-hero__name { font-size:15px; }
  .dh-hero__site { font-size:14px; padding:8px 20px; }
  .dh-hero__roles { font-size:15px; gap:14px; }

  .dh-deut__conclusion { font-size:18px; padding:22px 22px; }

  .dh-question-card { padding:28px 22px; }
  .dh-question-card__label { font-size:13px; }

  .dh-dabela__card { padding:32px 22px; }

  .dh-strand__tribe { font-size:13px; }
  .dh-headlock__psalm .dh-body { font-size:20px; }
}
</style>